export default {
	product: {
		name: 'Nom',
		shortName: 'Nom court',
		showId: 'Identifiants',
		price: 'Prix',
		tva: 'TVA',
		type: 'Type',
		categories: 'Catégorie(s)',
		removed: 'Produits supprimés',
		place: 'Point de fabrication',
		space: 'espace',
		assign: 'Assigner / désassigner un produit',
		add: 'Ajouter',
		confirm: 'Êtes-vous sûr(e) de vouloir supprimer ce produit ?',
		deleteConfirm:
			'Êtes-vous sûr(e) de vouloir supprimer le produit "%{name}" ?',
		duplicateConfirm:
			'Êtes-vous sûr de vouloir dupliquer ce produit ? Cette opération dupliquera également sa présence dans les catégories',
		deleteBulkConfirm:
			'Êtes-vous sûr(e) de vouloir supprimer tous ces produits ?',
		free_price: 'PRIX LIBRE',
		productInCreation:
			'Veuillez enregistrer votre nouveau produit: %{productName} avant de modifier un produit déjà existant.',
		productTypeChange:
			'Vous avez changé le type de produit %{productName}, pensez à vérifier le point de fabrication et sa TVA.',
		productTVAChange:
			'Vous avez changé le taux de TVA du produit %{productName}, pensez à vérifier le type du produit.',
		disalowAutoFillForPrice:
			'Modification non appliquée à partir du produit %{productName}. Cette action est interdite sur les prix au détail.',
		disalowForFreePrice:
			'Modification non appliquée à partir du produit %{productName}. Cette action est interdite sur les prix libres.',
		disalowForProductVolume:
			'Vous ne pouvez pas copier le prix sur des produits ayant un prix au détail ou un prix libre.',
		productTVAAjusted:
			'La TVA a été changée automatiquement sur le produit %{productName}.',
		skuRequired: 'Le champ SKU est requis',
		skuIntRequired: 'Le champ SKU est requis et doit être un nombre entier',
		category_empty: 'Aucun produit associé à cette catégorie',
		nb_supplements: 'Nombre de suppléments',
		nb_prices: 'Nombre de catégories de prix',
		select_all: 'Tout sélectionner  / désélectionner',
		wrongPrice:
			'Vous avez renseigné un prix pour %{productName} au mauvais format',
		no_visible: 'NON VISIBLE',
		disabled: 'INDISPONIBLE',
		disaplay_disable_product: 'Afficher les produits indisponibles',
		copy_label: 'Copie',
		form: {
			supp: {
				min: 'Minimum',
				max: 'Maximum',
				required: 'Obligatoire',
				minMax: 'Min/Max',
				name: 'Nom',
			},
			reset_overrides: 'Revenir à la version siège',
			confirm_reset_overrides:
				'Êtes-vous sûr de vouloir revenir à la version siège sur ce produit (cette opération supprimera les modifications spéciiques appliquées à ce produit) ?',
			name: 'Nom',
			id: 'Identifiant :',
			shortName: 'Nom court (Facultatif)',
			description: 'Description (Facultatif)',
			price: 'Prix',
			price_default: 'Prix par défaut',
			tax: 'TVA',
			type: 'Type',
			category: 'Catégorie(s)',
			no_place: 'Aucun',
			place: 'Point de fabrication 1',
			place2: 'Point de fabrication 2 (Facultatif)',
			statusSend: "Temps d'envoi",
			visible: 'Visible',
			available: 'Disponible',
			available_help: 'Aide sur la gestion des indisponibilités des produits',
			available_doc:
				'https://laddition.slite.page/p/dzBfIQQb9CMHu3/Gestion-des-indisponibilites-des-produits',
			exclusion: 'Exclusions',
			direct: 'Direct',
			sku: 'SKU (Facultatif)',
			sku_required: 'SKU (Obligatoire)',
			purchase_price_help:
				'Cliquez ici pour comprendre le prix d’achat HT et analyser la rentabilité d’un produit',
			purchase_price_ht: "Prix d'achat HT (Facultatif)",
			free_price: 'Prix libre',
			returnable: 'Consigne',
			returnable_help:
				'Activer seulement pour les produits de type Location / Prestation de service (ex : gobelet plastique, plat en verre, retour, etc.)',
			no_name: 'Sans titre',
			binConfirmTitle: 'Récupération de produit(s)',
			binConfirmText:
				'Le(s) produit(s) suivant(s) supprimé(s) ont un nom similaire, souhaitez-vous récupérer ces informations pour pré-remplir le formulaire ? ',
			exclusion_label: 'Produit exclu pour les salles',
			retail_price: 'Prix au détail',
			select: 'Sélectionnez...',
			exclusion_select_all: 'Tout sélectionner',
			exclusion_deselect_all: 'Tout désélectionner',
			exclusion_select_grouo: 'Selectioner le groupe',
		},
		speedDial: {
			add_product: 'Nouveau produit (formulaire détaillé)',
			add_product_line: 'Nouveau produit (rapide)',
			add_product_menu: "Ajouter des produits à partir d'une carte existante",
			restore_from_bin: "Récupération d'un produit supprimé",
			add_product_menu_form: 'Nouveau menu (formulaire détaillé)',
		},
		tooltip_bulk_delete: 'Suppression de produits en masse',
		assign_form: {
			search: 'Chercher',
			title_delete_bulk: 'Suppression de produits',
			delete: 'Supprimer',
		},
		filter: {
			add_filter: 'Ajouter un filtre',
			color: 'Couleur',
			price: 'Prix',
			taxe_rate: 'TVA',
			product_type: 'Type',
			category: 'Catégorie',
			place_send: 'Lieu de fabrication',
			visible: 'Visible',
			no_category: 'Sans catégorie',
			search: 'Rechercher...',
		},
		sort: {
			category_asc: 'Ordre des catégories ascendant',
			category_desc: 'Ordre des catégories descendant',
			category_A_Z: 'Ordre des catégories A-Z',
			category_Z_A: 'Ordre des catégories Z-A',
			product_asc: 'Nom de produit A-Z',
			product_desc: 'Nom de produit Z-A',
			price_asc: 'Prix croissant',
			price_desc: 'Prix décroissant',
			visible: 'Visible',
			not_visible: 'Non visible',
			or: ' Ou ',
		},
		types: {
			solid: 'Solide',
			alcool: 'Alcool',
			no_alcool: 'Non Alcool',
		},
		popUpAddProduct: {
			title: 'Importer des produits depuis la carte : ',
			import: 'Importer',
		},
		grid: {
			price_mode: 'Gestion des prix',
			stock_mode: 'Gestion des stocks',
			delete_mode: 'Suppression de masse',
		},
		duplicate_success: 'Le produit à bien été dupliqué',
		restore: {
			title_restore_product: 'Restauration de produits',
			title_restore_supp: 'Restauration de suppléments',
			title_restore_menu: 'Restauration de menu',
			description_restore:
				'Cliquez sur un élément pour le récupérer de la corbeille',

			secondary: 'Créé le %{created} - Supprimé le %{updated} (ID : %{id})',
			success:
				'Le produit "%{name}" a été restauré. Pensez à lui ré-affecter une catégorie',
			product_menu_success:
				'Le menu "%{name}" a été restauré. Vous pouvez lui ré-affecter des produits',
		},
	},
	url: {
		category: 'categorie',
		product: 'produit',
		tax: 'tax',
		supplement: 'supplement',
		placeSend: 'placeSend',
		product_menu: 'produitMenu',
		price_category: 'categoriePrix',
		floor: 'salle',
		category_display: 'Catégories',
		product_display: 'Produits',
		importCatalog_display: "Importer à partir d'un fichier Excel",
		importCatalog_nav_label: 'Importer',
		importCatalog_nav_label_reimport: 'Ré-importer',
		tax_display: 'TVA',
		supplement_display: 'Suppléments',
		placeSend_display: 'Fabrication',
		menu_display: 'Menu',
		price_category_display: 'Catégorie de Prix',
		floor_display: 'Salles / Activités',
		deploy: 'gestionDeploiement',
		deploy_display: 'Déploiement',
		menu: 'menu',
		menuBin: 'corbeilleMenu',
	},
	importCatalog: {
		unavailable_child:
			"L'import n'est pas disponible sur un établissement rattaché à un master : sa carte lui est transmise par déploiement depuis le master.",
		unavailable_master_reimport:
			"Le réimport n'est pas disponible sur un master : sa carte est descendue chez tous ses établissements, la réécrire depuis un tableur remplacerait celle de toute la chaîne. L'import reste disponible sur une carte vierge.",
		unavailable_zone:
			"L'import n'est pas disponible lorsqu'une zone est sélectionnée : une zone est un périmètre de déploiement, elle n'a pas de carte propre. Revenez sur la carte du master pour importer.",
		tab_products: 'Produits',
		tab_menus: 'Menus',
		tab_modifiers: 'Modificateurs',
		tab_unavailable_reimport:
			"Le ré-import ne gère que les produits. Les menus et les modificateurs ne s'importent que sur une carte vierge : ils ne savent pas se comparer à la carte en place et la dupliqueraient.",
		tab_unavailable: 'Disponible prochainement',
		help_link: 'Comment ça fonctionne ?',
		download_template_button: 'Télécharger un modèle',
		column_category_label: 'Colonne "Catégorie" (facultatif) :',
		column_name_label: 'Colonne "Nom" :',
		column_price_label: 'Colonne "Prix" :',
		column_status_send_label: 'Colonne "Suite d\'envoi" (facultatif) :',
		column_type_label: 'Colonne "Type" (facultatif) :',
		column_tax_rate_label: 'Colonne "Taux de TVA" (facultatif) :',
		column_place_send_label: 'Colonne "Lieu d\'envoi" (facultatif) :',
		column_color_label: 'Colonne "Couleur" (facultatif) :',
		column_purchase_price_label: 'Colonne "Prix d\'achat HT" (facultatif) :',
		expected_values_purchase_price:
			"Valeurs acceptées : un prix d'achat HT positif (2,10). Vide ou 0 : le prix d'achat HT du produit reste inchangé.",
		expected_values: 'Valeurs reconnues : %{values}',
		tips_title: 'Conseils pour un fichier bien reconnu :',
		tips_category:
			'Colonne "Catégorie" (facultatif) — en-têtes reconnus : %{headers} — valeurs reconnues : %{values}',
		tips_category_empty:
			'Colonne "Catégorie" (facultatif) — en-têtes reconnus : %{headers} — valeurs possibles : nouvelle catégorie, famille ou classification du produit dans la caisse',
		category_no_existing_values:
			'Valeurs possibles : nouvelle catégorie, famille ou classification du produit dans la caisse',
		category_new: '%{name} (nouvelle catégorie)',
		tips_name: 'Colonne "Nom" (obligatoire) — en-têtes reconnus : %{values}',
		tips_price: 'Colonne "Prix" (obligatoire) — en-têtes reconnus : %{values}',
		tips_status_send:
			'Colonne "Suite d\'envoi" (facultatif) — en-têtes reconnus : %{headers} — valeurs acceptées : %{values}',
		tips_type:
			'Colonne "Type" (facultatif) — en-têtes reconnus : %{headers} — valeurs reconnues : %{values}',
		tips_tax_rate:
			'Colonne "Taux de TVA" (facultatif) — en-têtes reconnus : %{headers} — valeurs reconnues : %{values}',
		tips_place_send:
			'Colonne "Lieu d\'envoi" (facultatif) — en-têtes reconnus : %{headers} — valeurs reconnues : %{values}',
		tips_color:
			'Colonne "Couleur" (facultatif) — en-têtes reconnus : %{headers} — valeurs reconnues : %{values}',
		tips_purchase_price:
			"Colonne \"Prix d'achat HT\" (facultatif) — en-têtes reconnus : %{headers} — valeurs acceptées : un prix d'achat HT positif. Laissée vide ou à 0, elle ne modifie pas le prix d'achat HT déjà enregistré.",
		choose_placeholder: '-- choisir --',
		validation_errors_intro:
			'Le fichier contient des lignes invalides, corrigez-les avant de réessayer :',
		error_missing_name: 'Ligne %{line} : nom manquant',
		error_invalid_price: 'Ligne %{line} : prix invalide (%{value})',
		error_price_is_date: 'Ligne %{line} : le prix a été interprété comme une date par votre tableur. Reformatez la cellule en nombre, ou saisissez le prix avec une virgule (2,10).',
		error_invalid_purchase_price:
			"Ligne %{line} : prix d'achat HT invalide (%{value}). Attendu : un nombre positif, ou une cellule vide pour ne rien changer.",
		error_purchase_price_is_date:
			"Ligne %{line} : le prix d'achat HT a été interprété comme une date par votre tableur. Reformatez la cellule en nombre, ou saisissez le prix avec une virgule (2,10).",
		error_missing_id_column:
			'La carte contient déjà des produits : le fichier doit comporter une colonne « ID ». Téléchargez le modèle pour l\'obtenir.',
		error_unknown_id:
			'Ligne %{line} : l\'identifiant « %{id} » ne correspond à aucun produit de la carte. Laissez la cellule vide pour créer un produit, ou reprenez une valeur du modèle téléchargé.',
		error_duplicate_id:
			'Ligne %{line} : l\'identifiant « %{id} » apparaît plusieurs fois dans le fichier.',
		table_header_id: 'ID',
		id_new: 'Nouveau',
		table_header_category: 'Catégorie',
		table_header_name: 'Nom',
		table_header_price: 'Prix',
		table_header_status_send: "Suite d'envoi détectée",
		table_header_type: 'Type détecté',
		table_header_tax_rate: 'Taux de TVA détecté',
		table_header_place_send: "Lieu d'envoi détecté",
		table_header_color: 'Couleur détectée',
		table_header_purchase_price: "Prix d'achat HT",
		type_drink: 'Boisson',
		type_solid: 'Solide',
		submit_button: 'Importer',
		submit_button_reimport: 'Ré-importer',
		file_read_error:
			"Impossible de lire ce fichier. Vérifiez qu'il s'agit bien d'un fichier Excel valide.",
		import_success:
			"L'import de %{nb} produit(s) a été réalisé avec succès",
		import_purchase_price_failure:
			"Les produits ont bien été importés, mais les prix d'achat HT n'ont pas pu être enregistrés. Renseignez-les depuis l'onglet Quantités.",
		import_failure: "L'import de %{nb} n'a pas pu être réalisé",
		import_unchanged: "%{nb} produit(s) étaient déjà à jour : rien n'a été modifié pour eux",
		confirm_title: 'Vérifiez avant d\'importer',
		confirm_replaced: '%{count} ligne(s) du fichier portent un identifiant : seules celles réellement modifiées seront appliquées',
		confirm_created: '%{count} produit(s) seront créés',
		confirm_purge_warning:
			'Attention : toutes les modifications en cours de cette carte seront supprimées, y compris le contenu des déploiements programmés.',
		confirm_purge_warning_products:
			'Attention : les modifications en cours des produits et catégories de cette carte seront supprimées, y compris dans les déploiements programmés. Celles des menus et des modificateurs sont conservées.',
		confirm_untouched:
			'Les produits de la carte qui n\'apparaissent pas dans le fichier ne seront ni modifiés ni supprimés.',
		confirm_replace_all:
			'Cette carte n\'est pas encore déployée : son contenu actuel sera entièrement remplacé par celui du fichier.',
		confirm_deleted_products: '%{count} produit(s) seront supprimés',
		confirm_deleted_categories: '%{count} catégorie(s) seront supprimées',
		confirm_cancel: 'Annuler',
		confirm_apply: 'Importer',
		confirm_apply_reimport: 'Ré-importer',
		tips_id:
			'Colonne "ID" (facultative sur une carte vide, obligatoire dès que la carte contient des produits) — en-têtes reconnus : %{headers} — valeurs : identifiants du modèle téléchargé.',
		tips_untouched:
			'Les produits absents du fichier sont laissés intacts : l\'import ajoute et remplace, il ne supprime jamais.',
		tips_replace_all:
			'Cette carte n\'est pas encore déployée : l\'import remplacera l\'intégralité de son contenu actuel par celui du fichier.',
		confirm_multi_category:
			'%{count} produit(s) appartiennent à plusieurs catégories. Le fichier n\'en porte qu\'une par produit : les autres seront perdues à l\'import.',
		error_empty_file: 'Le fichier ne contient aucune ligne de produit.',
		tips_row_order:
			"L'ordre des lignes du fichier détermine l'ordre d'affichage des produits dans la carte.",
		confirm_submitting: 'Import en cours, ne fermez pas cette page…',
		column_stock_label: 'Colonne "Stock" (facultatif) :',
		expected_values_stock:
			'Valeurs acceptées : un nombre entier positif ou nul (12). Vide : le stock du produit reste inchangé.',
		tips_stock:
			'Colonne "Stock" (facultatif) — en-têtes reconnus : %{headers} — valeurs acceptées : un nombre entier positif ou nul. Laissée vide, elle ne modifie pas le stock ; renseignée, elle active le suivi du stock (type global) et fixe la quantité.',
		error_invalid_stock:
			'Ligne %{line} : stock invalide (%{value}). Attendu : un nombre entier positif ou nul, ou une cellule vide pour ne rien changer.',
		error_stock_is_date:
			'Ligne %{line} : le stock a été interprété comme une date par votre tableur. Reformatez la cellule en nombre.',
		table_header_stock: 'Stock',
		import_stock_failure:
			"Les produits ont bien été importés, mais le stock n'a pas pu être enregistré. Renseignez-le depuis l'onglet Quantités.",
		empty_file_wipe_notice:
			"Le fichier ne contient aucune ligne de produit. Vous pouvez l'utiliser pour vider entièrement la carte actuelle.",
		submit_button_empty_wipe: 'Vider la carte',
		confirm_wipe_warning:
			"Aucune ligne du fichier ne porte d'identifiant : tous ses produits seront créés. Si vous choisissez de supprimer la carte actuelle (produits, menus, modificateurs, catégories, prix), elle le sera avant l'import. Le suivi de stock sera alors désactivé pour toutes les cartes du compte, pas seulement celle-ci, et les prix d'achat et ajustements de stock saisis au back-office seront effacés. Les frais de livraison et de service ne sont pas touchés. Cette action est irréversible.",
		confirm_wipe_empty_file:
			"Votre fichier ne contient aucun produit : la carte (produits, menus, modificateurs, catégories, prix) sera entièrement vidée et rien ne sera importé. Le suivi de stock sera désactivé pour toutes les cartes du compte, pas seulement celle-ci, et les prix d'achat et ajustements de stock saisis au back-office seront effacés. Les frais de livraison et de service ne sont pas touchés. Cette action est irréversible.",
		confirm_without_wipe_notice:
			"Importer sans supprimer : la carte actuelle est conservée et les produits du fichier s'y ajoutent (risque de doublons).",
		confirm_wipe_apply: 'Supprimer la carte puis importer',
		confirm_apply_without_wipe: 'Importer sans supprimer',
		confirm_wipe_empty_file_apply: 'Vider la carte',
		import_wipe_success: 'La carte précédente a été supprimée.',
	},
	mergeRules: {
		tabHistory: 'Historique des modifications',
		logDate: 'Date',
		logUser: 'Utilisateur',
		logChange: 'Modification',
		logEmpty: 'Aucune modification enregistrée',
		logRule: '%{type} — %{field} : %{before} → %{after}',
		logPermissionGranted: 'Autorisation « %{name} » accordée',
		logPermissionRevoked: 'Autorisation « %{name} » retirée',
		logSpecialRightsEnabled: 'Droits spéciaux activés',
		logSpecialRightsDisabled: 'Droits spéciaux désactivés',
		logCopyRules: 'Règles copiées depuis %{source}',
		logCopyRestrictions: 'Autorisations copiées depuis %{source}',
		copyRestrictionsTitle: 'Copier les autorisations caisse',
		copyRestrictionsWarning:
			'Les droits spéciaux et l’état de chaque autorisation seront alignés sur ceux de l’établissement source.',
		copy: 'Copier',
		copyTitle: 'Copier les règles',
		copyIntro:
			'Les règles de %{source} vont remplacer celles des établissements cochés.',
		copyWarning:
			'Le remplacement est complet : une règle que la cible avait en propre et que la source n’a pas sera supprimée.',
		copyConfirm: 'Copier',
		tabSync: 'Synchronisation menu/caisse',
		tabRestrictions: 'Autorisations caisse',
		specialRights: 'Droits spéciaux',
		specialRightsHelp:
			'Sans droits spéciaux, les autorisations ci-dessous restent consultables mais ne sont pas modifiables.',
		restrictions: {
			productPrice: 'Modification du prix (produit)',
			supplementPrice: 'Modification du prix (modificateur)',
			productName: 'Modification du nom (produit)',
			supplementName: 'Modification du nom (modificateur)',
			productAdd: 'Ajout de produit/menu',
			supplementAdd: 'Ajout de modificateur',
			productShortName: 'Modification du nom court (produit)',
			productVat: 'Modification de la TVA (produit)',
			productDelete: 'Suppression de produit',
			supplementDelete: 'Suppression de modificateur',
		},
		placeSendMapping: {
			button: 'Correspondance des points de fabrication',
			title: 'Points de fabrication — %{company}',
			intro:
				"Associez chaque point de fabrication du siège à celui de l'établissement qui doit le recevoir au déploiement.",
			colMaster: 'Siège',
			colChild: 'Établissement',
			none: 'Non associé',
			remove: 'Supprimer la correspondance',
			empty: "Aucun point de fabrication au siège.",
			noIp: 'Aucune IP',
			saveFail: "La correspondance n'a pas pu être enregistrée.",
		},
		annexPrice: {
			question:
				'Appliquer aussi « %{status} » sur le prix des prix annexes (Prix/Catégorie de prix) ?',
		},
		confirmSiege:
			'Voulez-vous vraiment utiliser les valeurs de %{field} provenant du siège ? Les valeurs personnalisées seront écrasées et reprendront leur état initial',
		doc: 'Comprendre les règles',
		establishment: 'Établissement :',
		master: 'Siège/Zones',
		noChildren: 'Aucun établissement lié à ce compte',
		allSame: 'Les %{n} établissements ont tous les mêmes règles',
		groupsCount:
			'Les %{n} établissements se répartissent en %{k} jeux de règles différents',
		childAllSame: 'Règles identiques à celles de tous les autres établissements',
		childUnique: 'Jeu %{group} — règles propres à cet établissement',
		childShared: 'Jeu %{group} — partagé avec %{n} autre(s) établissement(s)',
		groupTag: 'jeu %{group}',
		button: 'Règles',
		title: 'Règles de synchronisation',
		category: 'Catégorie :',
		colField: 'CHAMP',
		colStatus: 'STATUT',
		empty: 'Aucune règle de synchronisation pour ce compte',
	},
	header: {
		modeAuto: 'Déploiement automatique',
		modeManual: 'Déploiement manuel',
		modeAutoHelp:
			'Mode automatique : la caisse récupère et applique automatiquement les modifications de carte si elle est connectée et au premier plan. Pour modifier le mode d’application, activez ou désactivez L’Addition Menu depuis l’espace partenaires.',
		modeManualHelp:
			'Mode manuel : les modifications de carte sont récupérées par la caisse lors d’une synchronisation, puis appliquées après confirmation. Pour modifier le mode d’application, activez ou désactivez L’Addition Menu depuis l’espace partenaires.',
		lastSync: 'Synchro le %{date} %{time}',
		lastSyncFull: 'Caisse synchronisée le %{date} à %{time}',
		update: 'Modifier le nom des modifications',
		delete: 'Supprimer les modifications du jour',
		menu: 'Vers le gestionnaire des cartes',
		logout: 'Déconnexion',
		reset: 'Suppression des modifications du %{date}',

		espaceClient: 'Mon Espace Client',
	},
	deploy: {
		title: 'Gestion du déploiement des modifications',
		titleNewClient: 'Initialisation de votre carte',
		recap: {
			name: 'Nom de vos modifications',
			dateDeploy: 'Date du déploiement',
			nameRestaurant: 'Le patch a été déployé sur votre établissement',
			children:
				'Le patch a également été déployé sur les établissements suivants',
			title: 'Récapitulatif du déploiement',
			description:
				'Vos modifications du %{date} concernant la carte “%{nameMenu}” viennent d’être déployées. ',
			immediatly: 'Immédiatement',
			immediateDeploy:
				'Les données sont transmises à l’iPad et seront prises en compte à la date prévue',
			when: 'Quand ?',
			company: 'Etablissement',
			other_companies: 'Etablissement(s)',
			and_other_companies: 'Et %{nb} autre établissements',
			zone: 'Zone',
		},
		history: {
			tabDeploy: 'Déployer',
			tabHistory: 'Derniers déploiements',
			tabChildren: 'Vue par établissement',
			title: 'Les %{count} derniers déploiements',
			titleChildren: 'Dernier déploiement de chaque établissement',
			empty: 'Aucun déploiement',
			emptyChildren: 'Aucun établissement lié à cette carte',
			colCompany: 'Établissement',
			colCreation: 'Création',
			colName: 'Nom',
			colStatus: 'État',
			colDate: "Date d'effet",
			colRemoved: 'Supprimé',
			statusApplied: 'Appliqué',
			statusApplying: 'En cours',
			statusFetched: "Récupéré par l'iPad",
			statusPending: 'Non appliqué',
			statusRemoved: 'Supprimé',
			removedYes: 'Oui',
			removedNo: 'Non',
			colDescription: 'Description',
			toggleContent: 'Afficher les changements',
			more: 'Voir plus',
			loading: 'Chargement…',
			changeDate: 'Changer la date',
			dateTitle: 'Date d’effet de « %{name} »',
			dateIntro:
				'Le déploiement partira à cette date. Les modifications qu’il porte sont replacées en conséquence.',
			dateSuccess: 'Date d’effet reportée au %{date}',
			dateFail: 'La date d’effet n’a pas pu être modifiée',
			confirmCancel:
				'Supprimer le déploiement « %{name} » ? Les modifications qu’il porte seront perdues.',
			export: 'Exporter (XLS)',
			exportFail: "L'export n'a pas pu être généré",
			contentEmpty: 'Aucun changement enregistré pour ce déploiement',
			contentCount: '%{shown} changements affichés sur %{total}',
		},
		warning: 'Attention',
		weirdVatProducts:
			"Les produits suivants ont une TVA incohérente avec le type de produit. Si ce n'est pas le cas dans votre contexte, ignorez ces informations.",
		weirdPlaceSendProducts:
			"Les produits suivants ont un point de fabrication incohérent avec le type de produit. Si ce n'est pas le cas dans votre contexte, ignorez ces informations.",
		confirm_weird:
			'Certains produits ont une TVA ou un point de fabrication incohérent avec le type de produit. Voulez-vous quand même déployer ces modifications ?',
		unknowVAT: 'TVA inconnue',
		unknowPlaceSend: 'Point de fabrication inconnu',
		dayOfDeploy: 'Jour du déploiement',
		scope: {
			title: 'Portée du déploiement',
			all: 'Déployer partout',
			all_help: 'Le master et tous les établissements liés à cette carte',
			master: 'Uniquement sur le master',
			master_help:
				'Les établissements liés recevront ces modifications au prochain déploiement complet',
		},
		form: {
			name: 'Nom de la modification',
			date: 'Date du déploiement',
			now: 'Déployer maintenant',
			later: 'Déployer ultérieurement à la date : ',
			createMenu: 'Initialiser la carte',
			submit: 'Déployer',
			seeChanges: 'Voir les modifications en cours',
			nameNewClient: "Nom de l'initialisation",
			placeHolderRestaurant: 'Nom du restaurant',
			restaurant_select_all: 'Tout sélectionner  / désélectionner',
			restaurant_empty: 'Aucun restaurant',
			toBeDeployed: 'Déploiement prévu le : ',
			noDeploy: 'Impossible de modifier la sélection',
			impossibleAction:
				'Déployer maintenant - Action impossible, un déploiement est déjà prévu',
			assignRestaurant:
				"Choisir et déployer également sur d'autres restaurants",
			titleAssignator: 'Choisir mes restaurants',
			warningDeleteChildren:
				'Attention, cela supprimera le déploiement sur les restaurants précédemment choisis',
			warningDate:
				"Impossible de déployer une modification si la date et l'heure sont inférieures au dernier déploiement prévu",
			warningOneDate:
				'Vous ne pouvez pas déployer une modification avant 24 heures',
			defaultName: 'Modifications du %{date}',
		},
		menu_display: 'Menus',
		price_category_display: 'Catégories de prix',
		floor_display: 'Salles / Activités',
	},
	tax: {
		name: 'Nom',
		rates: 'Taux',
		rate: 'Taux sur place (%)',
		rate_take_away: 'Taux à emporter (%)',
		rate_delivery: 'Taux en livraison (%)',
		labelTaxRateError: 'Ce champ doit comporter un nombre entre 0 et 100.',
		confirm: 'Êtes-vous sûr(e) de vouloir supprimer cette TVA ?',
		default: 'Par défaut',
		active: 'Actif',
		editConfirm:
			'Attention : cette TVA est associée à %{count} produit(s), êtes-vous sûr(e) de vouloir la modifier ?',
	},
	category: {
		restore: {
			newCategory: 'Nouvelle catégorie',
			restoreCategory: 'Restaurer une ancienne catégorie',
			title: 'Restaurer une catégorie',
			intro:
				'Choisissez la catégorie à remettre sur la carte. Elle sera replacée à la fin de la liste.',
			empty: 'Aucune catégorie supprimée à restaurer.',
			linkedCount: 'produit(s) étaient dans cette catégorie et lui seront rattachés',
			deleted: 'supprimé',
			productsCount:
				'Remettre en vente les %{count} produit(s) supprimé(s) de cette liste',
			productsHelp:
				'Les produits encore en vente sont rattachés dans tous les cas. Décochez pour laisser les produits supprimés en dehors de la carte : ils ne seront alors pas rattachés non plus.',
			noProduct: 'Aucun produit connu pour cette catégorie.',
			andMore: 'et %{count} de plus',
			confirm: 'Restaurer',
			done: 'Catégorie « %{name} » restaurée',
			doneLinked:
				'Catégorie « %{name} » restaurée, %{linked} produit(s) rattaché(s)',
			doneWithProducts:
				'Catégorie « %{name} » restaurée, %{count} produit(s) remis en vente et %{linked} rattaché(s)',
		},
		empty: "Aucune catégorie de produits n'est configurée",
		empty_exemple: 'Exemples : Entrées, Plats, Vins...',
		name: 'Nom',
		color: 'Couleur',
		icon: 'Icône',
		all: 'Tous les produits',
		confirm:
			"Êtes-vous sûr(e) de vouloir supprimer cette catégorie ? Les produits contenus dans la catégorie ne seront pas supprimés et seront toujours visibles dans 'Tous les produits'.",
		deleteConfirm: 'Confirmation de suppression',
		no_category: 'Sans catégorie',
		already_selected: 'Déjà sélectionné',
		product: {
			price: 'Prix à la carte',
			type: 'Type',
			tax: 'TVA',
			place_send: 'Point de fabrication',
			places_send: 'Points de fabrication',
			alert_price:
				'Vous ne pouvez pas ajouter des produits à 0.00%{currency} dans un menu.',
		},
		not_visible: 'NON VISIBLE',
		not_visible_tooltip: 'Exclu de toutes les salles',
	},
	supplementCategory: {
		empty: 'Aucune catégorie de suppléments configurée',
		empty_exemple: 'Exemples : Cuisson, Parfums de glace...',
		form_name: 'Nom de la catégorie de suppléments',
		name: 'nom',
		color: 'couleur',
		icon: 'icône',
		type1: 'Un seul choix',
		type2: 'Plusieurs choix',
		type3: 'Plusieurs choix en quantité',
		confirm:
			'Êtes-vous sûr(e) de vouloir supprimer cette catégorie de suppléments ?',
		assign_product: 'Assigner des produits',
		min: 'min',
		max: 'max',
		labelMultiple:
			'Les articles associés régissent à la règle suivante (0 = falcultatif)',
		labelUnique: 'La saisie pour les articles associés est',
		add: 'Ajouter une catégorie de suppléments',
		changes_confirmation:
			'Voulez-vous appliquer les changements sur les produits liés à cette catégorie de supplément',
	},
	floorPriceCategoryReweight: {
		title: 'Gestion des priorités de catégories de prix',
		name: 'Catégories de prix',
		floors: 'Salles',
	},
	supplement: {
		empty: 'Aucun supplément configurée',
		empty_exemple: 'Exemples : Vanille, Fraise, Saignant, A point ...',
		name: 'Nom du supplément',
		price: 'Prix',
		confirm: 'Êtes-vous sûr(e) de vouloir supprimer ce supplément ?',
		add: 'Ajouter un supplément',
		add_restore: 'Restaurer un supplément supprimé',
		addSpace: 'Ajouter un espace',
		sku: 'SKU',
	},
	generalButtons: {
		cancel: 'Annuler',
		ok: 'Ok',
		yes: 'Oui',
		no: 'Non',
		edit: 'Modifier',
		delete: 'Supprimer',
		reload: 'Recharger',
		close: 'Fermer',
	},
	user: {
		login: 'Se connecter',
		confirmLogout: 'Êtes-vous sûr de vouloir vous déconnecter ?',
	},
	productMenu: {
		name: 'Nom',
		shortName: 'Nom court',
		empty: 'Aucun menu configuré',
		price: 'Prix',
		tax: 'TVA',
		visible: 'Visible',
		confirmMenu: 'Êtes-vous sûr(e) de vouloir supprimer ce menu ?',
		confirmMenuLevel:
			'Êtes-vous sûr(e) de vouloir supprimer ce niveau de menu ?',
		nbMenuLevel: 'Niveaux',
		nbProduct: 'Produits',
		next: 'Suivant',
		back: 'Retour',
		levelName: 'Niveau de menu',
		excludedOn: 'Le menu est exclu pour :',
		title: 'Liste des menus',
		noProduct:
			'Vous devez configurer un produit avec un prix supérieur à 0.00 avant de configurer des menus',
		form: {
			titleCreation: "Création d'un menu",
			titleCreation2: 'Création du menu : ',
			name: 'Nom du menu',
			short_name: 'Nom court (Facultatif)',
			sku: 'SKU (Facultatif)',
			sku_required: 'SKU (Obligatoire)',
			color: 'Couleur du Menu',
			description: 'Description (Facultatif)',
			errorName: 'Champs requis',
			errorPrice: 'Nombre positif requis',
			price: 'Prix',
			defaultPrice: 'Prix par défaut',
			step1: 'Dénomination',
			step2: 'Prix et Exclusions',
			step3: 'Gestion des produits',
			step4: 'Validation',
			submit: 'Valider',
			defaultMenuLevelName1: 'Entrée',
			defaultMenuLevelName2: 'Plat',
			is_alternative: 'Facultatif',
			is_required: 'Obligatoire',
			requirement: 'Obligatoire',
			requirements: {
				complete: 'Pour compléter le menu seulement',
				manufacturing: "Pour l'envoi en cuisine",
				payment: "Pour l'encaissement",
				both: "Pour l'envoi en cuisine et l'encaissement",
			},
			is_menu_level: 'Niveau de menu',
			is_menu_level_help:
				'Toujours laisser activé sauf si le menu gère à la fois Entrée-Plat ou Plat-Dessert',
			is_required_manufacturing: "Obligatoire pour l'envoi en cuisine",
			add_menu_level: '+ Ajouter un niveau de menu',
			menu_level_form_name: 'Formulaire niveau de menu',
			product_menu_level_form_name: 'Formulaire Produit',
			active: 'Actif',
		},
	},
	menu: {
		addNew: 'Ajouter une nouvelle carte',
		active: 'Active',
		goToBin: 'Voir les cartes supprimées',
		modify: 'Modifier la carte',
		deploy: 'Gérer le déploiement',
		delete: 'Supprimer la carte',
		return: 'Retour en arrière',
		inactive: 'Inactive',
		removed: 'Supprimée',
		update: 'Modifier',
		permanent: 'Permanent',
		startDate: 'Date de début',
		endDate: 'Date de fin',
		resume: 'Résumé',
		company: 'Etablissement',
		institution: 'Etablissement(s)',
		product: 'Produit(s)',
		category: 'Catégorie(s)',
		carteSelected: 'Carte active iPad',
		nextPatch: 'Prochain déploiement',
		dateDeploy: 'Date déploiement',
		noFuturPatch: 'Aucun déploiement programmé',
		noAccess:
			'Pour accéder à la carte, veuillez effectuer une synchronisation depuis votre iPad principal',
		menu: 'Menu(s)',
		titlePopUpEdit: 'Modifier les informations',
		createMenu: 'Nous vous invitons à créer votre première carte',
		synchroCells: {
			never: 'Jamais déployé',
			noSynchro: 'Non synchronisé',
			synchroNoDeployed: 'Synchronisé non appliqué',
			synchro: 'Synchronisé',
		},
		synchroInstitution: 'Synchronisation établissements',
		synchro: 'Synchronisation',
		access: 'Cliquez ici pour accéder',
		deleteMenu:
			'Etes vous sûr de vouloir supprimer cette carte ? Tous les produits présents seront supprimés. Attention, cette action est irréversible',
		cards: 'carte(s)',
		currentCard: 'carte(s) en cours - ',
		pastCard: 'carte passée - ',
		futurCard: 'carte à venir - ',
		neverCurrentCard: 'Aucune carte en cours',
		neverPastCard: 'Aucune carte passée',
		neverFuturCard: 'Aucune carte à venir',
		form: {
			name: 'Nom de la carte',
			placeholderName: 'Hiver',
			errorName: 'Champ requis',
			startDate: 'Date de début',
			warning:
				'Attention, vous souhaitez supprimer cette carte, êtes-vous sûr ? Cette carte sera visible et récupérable pendant 1 mois avant sa suppression définitive.',
			warning2:
				'Attention, vous souhaitez restaurez cette carte, êtes-vous sûr ? Cette restauration peut entrainer des doublons avec vos produits.',
			warningCopy:
				"La création d'une nouvelle carte n'est utile seulement si vous souhaitez avoir au moins 50% de vos articles différents par rapport à votre carte actuelle",
			endDate: 'Date de fin',
			new: 'Toute nouvelle carte',
			copy: 'Copie à partir de',
			submit: 'Valider',
			submit2: 'Confirmer',
			add: 'Nouvelle carte',
			warningCopyMenu: `Une fois les éléments de la carte copiés, la nouvelle carte sera automatiquement déployée sans que vous n'ayez besoin d'effectuer un déploiement via la rubrique "Déployer". Pensez à indiquer une date de début si vous ne souhaitez pas qu'elle soit disponible sur l'iPad dès la prochaine synchronisation ou prochain service.`,
			cancel: 'Annuler',
			save: 'Enregistrer',
		},
		formCopy: {
			choiceElement: 'Choix des éléments à copier',
			category: 'Catégories de produits',
			categorySupplement: 'Catégories de suppléments',
			productsSelected: 'produits(s) sélectionné(s)',
			menusSelected: 'menu(s) sélectionné(s)',
			supplementSelected: 'supplément(s) sélectionné(s)',
			menus: 'Menus',
			integralCopy: "Copier l'intégralité de la carte",
		},
		patch: 'Patch en cours',
		patchName: 'Nom du patch',
		nbModif: 'Modification(s)',
		carteAccess: 'Accéder à la carte',
		startDatePermanent: 'Date de début permanente',
		endDatePermanent: 'Date de fin permanente',
		addMenuToRestaurant: {
			title: 'Lier vos établissements à votre carte',
			select: 'Sélection des établissements',
			selected: 'Etablissements liés',
			name: 'Nom',
			synchro: 'Synchronisation',
			beginDate: 'Date début',
			endDate: 'Date fin',
			edit: 'Modifier',
			validate: 'valider',
			cancel: 'Annuler',
			add: 'Ajouter',
			deAssign: 'Désassigner',
			close: 'Fermer',
			selectRestaurant: 'Aucun établissement à assigner',
			untiedRestaurant: 'Aucun établissement liès à la carte',
			confirmAssign: 'Êtes-vous sur de vouloir assigner cet établissement ?',
			confirmUntied: 'Êtes-vous sur de vouloir désassigner cet établissement ?',
			assign: 'assigner',
		},
		deploy: 'Gérer le déploiement',
		acess_menu_allready_in_use:
			"Attention, il semblerait qu'une session soit déjà ouverte avec cette carte. Voulez-vous tout de même y accéder ?",
		edits: {
			title: 'Modifications à venir',
			no_edits: 'Aucune modification en cours pour cette carte',
			create: 'création(s) %{type}',
			update: 'modification(s) %{type}',
			delete: 'suppression(s) %{type}',
			minorEdits: '%{nbModifs} modifications diverses',
			remainingEdits: 'et %{nbModifs} autres modifications',
			type: {
				category: 'de catégorie',
				product: 'de produit/menu/supplément',
				price: 'de prix',
				category_supplement: 'de supplement',
				price_category: 'de catégorie de prix',
				category_product: "de l'organisation des catégories",
				product_product: 'de liaisons produit-menu ou produit-supplément',
			},
		},
	},
	priceCategory: {
		name: 'Nom',
		name_short: 'Nom court',
		time: 'Durée',
		days: 'Jours',
		floors: 'Salles',
		active: 'Actif',
		deleteConfirm:
			'Êtes-vous sûr de vouloir  supprimer cette catégorie de prix ? Les prix associés seront supprimés toutes échéances comprises.',
		empty: 'Aucune catégorie de prix',
		empty_exemple: 'Exemples : Happy Hour, Terrasse ...',
		associations: 'Voir les associations',
		form: {
			name: 'Nom',
			name_short: 'Nom court (Facultatif)',
			time: 'Durée',
			days: 'Jours',
			days_label: 'Jours concernés par cette catégorie de prix',
			floors: 'Salles',
			floors_label: 'Salles concernées par cette catégorie de prix',
			active: 'Actif',
			start: 'Début',
			end: 'Fin',
			all_day: 'Toute la journée',
			display_settings: 'Affichage nom court',
			display_short_name_order: 'Affichage du nom court en commande',
			display_short_name_cashing: "Affichage du nom court à l'encaissement",
			display_short_name_manufacturing: 'Affichage du nom court en cuisine',
			associations: 'Produit(s) associé(s)',
			times: {
				from: 'De',
				to: 'à',
				tomorrow: 'le lendemain',
			},
			init: {
				button: 'Configuration rapide',
			},
			copy: {
				button: "Copier à partir d'une autre catégorie",
			},
			copyConfirmation:
				'Vous allez changer les prix de cette catégorie par ceux de la catégorie "%{categoryName}". Les prix de la catégorie actuelle seront remplacés. ',
			initConfirmation:
				'Vous allez configurer cette catégorie de prix ; si des prix ont été précédemment renseignés, ils seront écrasés. Voulez-vous continuer ?  ',
		},
		init: {
			no_category:
				'Veuillez configurer des catégories et y associer des produits',
			no_other_price_category: "Il n'existe aucune autre catégorie de prix",
			none: 'Aucun changement',
			reinit: 'Réinitialiser (suppression des prix)',
			price_fixed: 'Prix fixe',
			price_plus: 'Montant en plus',
			price_minus: 'Montant en moins',
			percent_plus: '% en plus',
			percent_minus: '% en moins',
		},
		popupAssociation: {
			type: 'Type',
			name: 'Nom',
			price: 'Prix',
			product: 'Produit',
			productMenu: 'Menu',
			supplement: 'Supplément',
			productInMenu: 'Produit Menu',
			empty:
				'Aucun(e) Produit / Menu / Supplément associé à cette catégorie de prix',
		},
		button_floor_price_category_weight:
			'Gérer les priorités de catégories de prix',
		initPercentage: {
			initsentence: 'Veuillez choisir la méthode pour les arrondis en %',
			warning: 'Attention',
			aroundMath: 'Arrondi mathématique',
			aroundTen: 'Arrondi à 0,10',
			aroundFive: 'Arrondi à 0,05',
			cancel: 'Annuler',
		},
		alert:
			'Les catégories de prix sont globales ; si vous supprimez une catégorie de prix, vous supprimez également tous les prix associés à cette catégorie de prix pour toutes les prochaines échéances.',
	},
	patchMenu: {
		deniedAccessText:
			'Un déploiement est en cours, vous ne pouvez pas accéder à votre carte pour le moment.',
		deniedAccessTitle: 'Attention',
		deniedAccessQuit: 'Quitter',
		confirmDelete:
			'Êtes-vous sûr de vouloir supprimer ce patch ? Cela supprimera également les modifications en cours',
		ipadChanges: "Les données de l'iPad ont été synchronisées.",
		ipadChangesCompany:
			"Les données de l'iPad ont été synchronisées pour l'établissement %{nameCompany} - Carte : %{nameMenu}",
		ipadNoChanges:
			"Les données de l'ipad n'ont pas pu être synchonisées pour la carte: %{nameMenu}",
		ipadNoChangesCompany:
			"Les données de l'ipad n'ont pas pu être synchonisées pour l'établissement : %{nameCompany} - Carte : %{nameMenu}",
		deniedModification:
			'Un déploiement est en cours, vous ne pouvez pas faire de modification pour le moment',
		warningDelete:
			' Êtes-vous sûr de vouloir supprimer les modifications en cours du %{date} ? Les valeurs propres à la date sélectionnée reprendront leurs valeurs initiales avant modification.',
		warningResetMaster:
			' Êtes-vous sûr de vouloir revenir à la version siège sur cet établissement ? Cette opération reviendra à la version siège entièrement (prix, disponibilité produits, etc.)',
		deploySuccess: 'Déploiement effectué avec succès',
		deploySuccessSynchro:
			"Déploiement effectué avec succès, en attente d'une synchronisation d'un iPad",
		resetFail:
			"La suppression des modifications a échoué (sauvegarde de la carte impossible) : rien n'a été supprimé.",
		resetSuccess:
			'Suppressions des modifications du jour effectuées avec succès',
		noModifications:
			"Impossible d'effectuer un déploiement car aucune modification n'a été réalisée.",
		disabledMasterMultiSelected:
			'Veuillez vous positionner sur une zone pour déployer les changements de carte',
		updateFail:
			'Erreur lors de la mise à jour du patch. Déploiement non effectué',
		deployFail: 'Error lors du déploiement des modifications',
		updatePatch: {
			title: 'Modifier',
			where: "Vous êtes sur l'écran de modification de patch",
			secondTitle: 'Modifier le nom de votre patch',
			thirdTitle: "Modifier l'heure de déploiement",
			failPrev: 'Vous ne pouvez pas modifier une date avant un patch existant',
			failAft: 'Vous ne pouvez pas modifier une date aprés un patch existant',
			failTime: "Vous ne pouvez rentrer une date avant l'heure actuelle",
			failBefore24H: 'Vous ne pouvez pas déployer un patch avant 24 heures',
		},
		deletePatchFail:
			'Vous ne pouvez pas supprimer un déploiement avant un autre déploiement de prévu',
		errorDeletePatch: "Oops, Une erreur s'est produite",
		display: {
			title: 'Patches à venir',
			date: 'Date de déploiement',
		},
		deleteSuccess: 'Déploiement supprimé avec succès',
	},
	changes: {
		reset: 'Supprimer',
		resetZone: 'Supprimer (zone)',
		edits: 'Modification(s) en cours',
		reset_to_master: 'Dupliquer version siège',
		exportLabel: 'Modifications du %{date}',
		detailEmpty: 'Aucune modification en cours',
	},
	childrenReset: {
		open: 'Supprimer (sites)',
		title: 'Supprimer les modifications en cours des sites',
		description:
			'Les modifications en cours du %{date} seront supprimées sur les établissements cochés. La carte de chaque site est sauvegardée avant.',
		resultIntro: 'Bilan de la suppression du %{date} :',
		selectAll: 'Tout sélectionner',
		unselectAll: 'Tout désélectionner',
		submit: 'Supprimer (%{count})',
		close: 'Fermer',
		confirm:
			'Supprimer les modifications en cours du %{date} sur %{count} établissement(s) ? Cette action est sans retour (une sauvegarde de chaque carte est faite avant).',
		status: {
			deleted: 'Supprimées',
			empty: 'Rien à supprimer',
			error: 'Échec',
		},
		fail: "La suppression n'a pas pu être effectuée",
	},
	childRefs: {
		open: 'Analyse des références',
		title: 'Références de %{company}',
		intro:
			"Analyser compare les produits, catégories et catégories de modificateurs de cet établissement avec ceux du siège, et liste ce que le siège n'a pas.",
		analyse: 'Analyser',
		import: 'Importer',
		importRemoved: 'Supprimer',
		asRemovedHelp:
			'Supprimer les enregistre au siège sans les mettre dans la carte.',
		nothing:
			"Le siège possède déjà toutes les références de cet établissement.",
		count: {
			products: 'produit(s) absent(s) du siège',
			menus: 'menu(s) absent(s) du siège',
			categories: 'catégorie(s) absente(s) du siège',
			supplementCategories:
				'catégorie(s) de modificateurs absente(s) du siège',
		},
		pendingLabel: 'En cours : %{label}',
		countDifferences: 'libellé(s) différent(s) entre le siège et le site',
		differencesHelp: 'Siège à gauche, site à droite. Signalé seulement.',
		entity: {
			product: 'Produit',
			menu: 'Menu',
			category: 'Catégorie',
			categorySupplement: 'Catégorie de modificateurs',
		},
		export: {
			differences: 'Exporter (XLS)',
			colEntity: 'Type',
			colId: 'Identifiant',
			colMaster: 'Libellé siège',
			colChild: 'Libellé site',
			colChildDraft: 'Libellé en attente (site)',
		},
		inactive: 'inactif',
		andMore: 'et %{count} autre(s)',
		notesTitle: 'Import et suppression',
		importWarning:
			"Reprises telles quelles, rangées en fin de liste. Les produits arrivent sans catégorie ni modificateur ; TVA et point de fabrication sans équivalent prennent ceux du siège.",
		imported: '%{count} référence(s) importée(s) au siège',
		importedRemoved:
			'%{count} référence(s) enregistrée(s) au siège, en supprimé',
		analyseFail: "L'analyse n'a pas pu être effectuée",
		importFail: "L'import n'a pas pu être effectué",
	},
	zoneManager: {
		open: 'Gérer les zones',
		title: 'Zones',
		empty: "Aucune zone. Tant qu'il n'y en a pas, la carte se déploie de la même façon sur tous les établissements.",
		create: 'Créer une zone',
		nameLabel: 'Nom de la zone',
		copyFrom: 'Reprendre les modifications en cours de',
		copyNone: 'Aucune',
		zoneMeta: '%{companies} établissement(s) — %{changes} modification(s) en cours',
		usageQuestion: 'À quoi va servir ce découpage ?',
		usage: {
			price: 'Des prix différents selon la zone',
			availability: 'Des produits disponibles ou non selon la zone',
			both: 'Les deux',
		},
		usageHelp: {
			price: 'Les prix de chaque zone résistent au déploiement du siège ; la disponibilité, elle, reste pilotée par le siège.',
			availability: 'La disponibilité de chaque zone résiste au déploiement du siège ; les prix, eux, restent pilotés par le siège.',
			both: 'Prix et disponibilité résistent tous deux au déploiement du siège.',
		},
		assignTitle: 'Affectation des établissements',
		assignWarning: '%{count} établissement(s) sans zone. Dès lors qu’une zone existe, tous doivent en avoir une.',
		noZone: 'Sans zone',
		copy: 'Copier depuis',
		copyTitle: 'Reprendre les modifications d’une autre zone dans « %{name} »',
		copyIntro: 'De quelle zone reprendre les modifications ?',
		copyWarning:
			'« %{target} » recevra les %{sourceChanges} modification(s) de « %{source} ». Ses %{changes} modification(s) actuelles seront remplacées.',
		copyConfirm: 'Remplacer',
		copied: '%{count} modification(s) reprises',
		copyFail: 'La copie n’a pas pu être effectuée',
		save: 'Enregistrer',
		close: 'Fermer',
		saveBlocked: "Affectez d'abord tous les établissements à une zone.",
		deleteTitle: 'Supprimer « %{name} »',
		deleteMove: 'Vers quelle zone déplacer les %{count} établissement(s) de cette zone ?',
		deleteChanges: 'Ses %{changes} modification(s) en cours seront perdues.',
		confirmDelete: 'Supprimer « %{name} » ? Ses %{changes} modification(s) en cours seront perdues.',
		created: 'Zone « %{name} » créée',
		firstCreated:
			'Zone « %{name} » créée. Les %{assigned} établissement(s) y ont été affectés, et les règles Prix et Actif/Inactif du siège ont été réglées en conséquence.',
		assigned: 'Affectation enregistrée',
		createFail: "La zone n'a pas pu être créée",
		renameFail: "La zone n'a pas pu être renommée",
		deleteFail: "La zone n'a pas pu être supprimée",
		assignFail: "L'affectation n'a pas pu être enregistrée",
	},
	stash: {
		title: 'Modifications mises de côté',
		contentEmpty: 'Aucun changement dans ce brouillon',
		button: 'Mettre de côté',
		namingTitle: 'Mettre les modifications de côté',
		namingDescription:
			'Les modifications en cours quittent la carte et sont conservées sous ce nom. Vous pourrez les reprendre à tout moment.',
		namingConfirm: 'Mettre de côté',
		autoName: 'Avant changement de règles du %{date}',
		autoCreated:
			"Les modifications en cours ont été mises de côté sous « %{name} », le passage en SIEGE allant les écraser au prochain déploiement.",
		autoCreatedChild:
			"Les modifications en cours de %{company} ont été mises de côté sous « %{name} », le passage en SIEGE allant les écraser au prochain déploiement. L'établissement les retrouvera dans son propre calendrier.",
		nameLabel: 'Nom',
		restore: 'Reprendre',
		restoreBlocked:
			"Reprise impossible tant que des modifications sont en cours : déployez-les, supprimez-les ou mettez-les de côté d'abord.",
		changes: '%{count} modification(s)',
		createdOn: 'mis de côté le %{date}',
		confirmRestore:
			'Reprendre « %{name} » ? Les modifications reviendront à la date du jour.',
		confirmDelete:
			'Supprimer définitivement « %{name} » ? Les modifications mises de côté seront perdues.',
		createSuccess: 'Modifications mises de côté sous « %{name} »',
		createFail: "Les modifications n'ont pas pu être mises de côté",
		masterSyncName: 'Synchronisation master avant mise de côté du %{date}',
		masterSynced:
			"Première mise de côté : les modifications en cours ont d'abord été déployées sur le master uniquement, pour mettre à jour ses tables sources.",
		restoreSuccess: 'Modifications reprises',
		restoreFail: "Les modifications n'ont pas pu être reprises",
		deleteFail: "Les modifications mises de côté n'ont pas pu être supprimées",
	},
	floor: {
		no_configuration_here:
			"Les salles et activités doivent être configurées directement sur l'application iPad.",
		empty: 'Aucune salle configurée',
		no_floors: 'Aucune salle',
		all: 'Toutes les salles',
		name: 'Nom',
		type: 'Type',
		takeaway: 'Restauration rapide',
		counter_type: {
			stay_in: 'Sur place',
			take_away: 'A emporter',
			delivery: 'Livraison',
		},
		form: {
			name: 'Nom',
			color: 'Couleur',
			category: 'catégorie',
			counter: 'Comptoir',
			general_options: 'Options générales',
			advanced_options: 'Options avancées',
			auto_order_closing: 'Fermeture auto',
			payment_after_ticket: 'Encaissement après ticket',
			flash_cashing: 'Encaissement flash',
			client: 'Ouverture automatique des clients',
			counter_type: 'Type',
			display_amount: 'Afficher le montant des commandes',
			print_auto_manufacturing_close:
				"Envoi automatique à la fermeture d'une commande",
			print_auto_manufacturing_exit:
				"Envoi automatique à la sortie d'une commande",
			print_auto_ticket_close_nb: 'Ticket(s) à imprimer',
			print_auto_ticket_close_cashed:
				'Afficher le montant encaissé sur le ticket',
			print_auto_ticket_close_status: 'Même si le ticket a déjà été imprimé',
		},
		exclusion_label: 'Interdire la sélection sur :',
		alert_floor_mapping:
			'Une ou plusieurs salles du compte ne sont pas liées à au moins une salle de chaque site, veuillez contacter le service technique',
	},
	days: {
		monday: 'Lundi',
		tuesday: 'Mardi',
		wednesday: 'Mercredi',
		thursday: 'Jeudi',
		friday: 'Vendredi',
		saturday: 'Samedi',
		sunday: 'Dimanche',
		EVERY_DAY: 'Tous les jours',
		no_days: 'Aucun jour',
	},
	retail: {
		type: {
			size: {
				title: 'Prix au mètre',
				unit: 'Mètre',
				subUnit: 'centimère',
			},
			time: {
				title: "Prix à l'heure",
				unit: 'Heure',
				subUnit: 'minute',
			},
			volume: {
				title: 'Prix au litre',
				unit: 'Litre',
				subUnit: 'centilitre',
			},
			weight: {
				title: 'Prix au Kg',
				unit: 'Kg',
				subUnit: 'gramme',
			},
		},
	},
	assignator: {
		tag_empty: 'Aucun produit sélectionné',
		category: 'Catégorie',
		menuLevel: 'Niveau de menu',
		supplementCategory: 'Catégorie de suppléments',
	},
	zone: {
		company_loaded: 'La carte de %{name} a été chargée avec succès',
		zone_loaded: 'La carte de %{name} a été chargée avec succès',
		master_loaded: 'La carte du siège a été chargée avec succès',
	},
	helper: {
		title: "Rubrique d'aide",
		button: "Besoin d'aide ?",
		close: 'Fermer',
		titles: {
			product: 'Produits',
			category: 'Catégories',
			supplement: 'Suppléments',
			menu: 'Menus',
			priceCategory: 'Catégories de prix',
			tax: 'TVA',
			patchMenu: 'Déploiements',
			quickstart: 'Par où commencer ?',
			video: 'Démonstration en vidéo',
			master: 'Master Multi-établissements',
		},
		sections: {
			quickstart: {
				title: 'Par où commencer ?',
				paragraph_1:
					'Bienvenue sur votre outil de gestion de carte en ligne. Vous allez dès à présent pouvoir créer et personnaliser la carte de votre établissement.',
				paragraph_2:
					'La "Carte Web" permet de créer tous les éléments de votre carte. Catégories, produits, suppléments, menus. ',
				paragraph_3:
					"Consultez les différentes sections de cette rubrique d'aide afin d'utiliser au mieux cet outil.",
				paragraph_4:
					'Pour retrouver cette section d\'aide, cliquez sur le bouton "Besoin d\'aide ?" en haut à gauche de la fenêtre.',
			},
			product: {
				title: 'Produits',
				create: {
					title: 'Créer un nouveau produit',
					paragraph_1:
						"Pour ajouter un nouveau produit, cliquez sur la croix rouge « + ». Deux icônes s'affichent alors de part et d'autre de cette croix :",
					fast: {
						title: '"Nouveau produit (rapide)" ',
						warning: 'Attention, ',
						paragraph_1:
							"(à gauche de la croix rouge) : permet d'ajouter une ligne en bas de la grille afin de créer rapidement un produit. Dans cette nouvelle ligne, vous pouvez saisir les informations du produit en cliquant directement dans chaque champ.",
						paragraph_1_2:
							" votre nouveau produit ne sera sauvegardé qu'après avoir cliqué sur l'icône verte '+' en bout de ligne.",
						paragraph_2:
							"Si vous souhaitez accéder au formulaire détaillé du produit, cliquez sur l'icône de modification (picto crayon) en fin de ligne.",
						paragraph_3:
							'Dans le cas où plusieurs de vos produits ont le même prix, TVA, Type, Catégorie et/ou point de fabrication, une astuce vous permet de simplifier le renseignement des champs pour vous éviter de remplir chaque champ.',
						paragraph_4:
							'Pour cela, créez vos produits en « Nouveau produit (rapide) ». Renseignez le nom de chacun, et renseignez le prix du premier produit. Puis cliquez sur le champ « Prix » de ce produit. Le champ s’entoure d’un cadre bleu avec un petit carré bleu dans l’angle en bas à droite. Avec votre souris, faites glisser ce petit carré sur les autres lignes de produit : le prix s’appliquera alors à tous les produits concernés.',
						paragraph_5:
							'Vous pouvez faire de même avec la TVA, le type, la catégorie et le point de fabrication.',
					},
					form: {
						title: '"Nouveau produit (formulaire détaillé)" ',
						content:
							"(à droite de la croix rouge) : permet d'accéder au formulaire détaillé de création de produit.",
						list: {
							name: {
								title: 'Nom : ',
								content:
									"(champ obligatoire) Libellé du produit utilisé par défaut dans l'application.",
							},
							short_name: {
								title: 'Nom court : ',
								content:
									'Libellé du produit utilisé, si l’option est activée dans la grille de produits durant la prise de commande et/ou sur les impressions (en cuisine et le ticket de caisse).',
							},
							sku: {
								title: 'SKU : ',
								content:
									'Si vous avez plusieurs établissements et des plats communs mais qui n’ont pas le même nom, entrez un code commun pour ce plat.',
							},
							description: {
								title: 'Description : ',
								content:
									'Description ou commentaire du plat (accessible lors de la prise de commande).',
							},
							price: {
								title: 'Prix : ',
								content: 'Prix TTC du produit.',
								paragraph_1:
									'Le prix peut aussi être « Libre », c’est-à-dire que l’application vous demandera de renseigner le prix souhaité lors de la commande du produit.',
								paragraph_2:
									"Le prix peut aussi être « au détail ». Pour cela cochez la coche « prix au détail » et sélectionnez l'unité de mesure (prix au kg, au mètre, au litre ou à l'heure) et renseignez le prix.",
								paragraph_3:
									"Si vous définissez des catégories de prix (ex : Happy hour), dans la rubrique « Catégorie de prix », vous pourrez choisir ici d'attribuer ou non la catégorie de prix à ce produit et de définir le prix pour le produit en question.",
							},
							visible: {
								title: 'Visible : ',
								content:
									'Rendre le produit visible ou non dans la prise de commande (en cas de produit non disponible temporairement ou hors saison) sans le supprimer de vos réglages de carte.',
							},
							vat: {
								title: 'TVA : ',
								content:
									'(champ obligatoire) Sélectionner le taux de TVA à appliquer sur ce produit.',
								paragraph:
									'Trois TVA sont pré-configurées. Vous pouvez configurer de nouveaux taux dans la rubrique « TVA ».',
							},
							type: {
								title: 'Type : ',
								content:
									'(champ obligatoire) Le type de produit est utilisé pour faire des rapports au sein de votre ou vos établissements (disponible dans le reporting en ligne). La liste des types de produits est prédéfinie. Lorsque vous cliquez sur le champ « Type », vous verrez apparaître la liste de tous les types possibles, avec l’information suivante : Solide, Alcool ou Non Alcool.',
							},
							category: {
								title: 'Catégorie : ',
								content:
									'Permet de classer le produit dans une ou plusieurs catégories de produit que vous avez créées dans la rubrique « Catégorie » (vous pouvez cocher plusieurs catégories).',
							},
							place_send_1: {
								title: 'Point de fabrication 1 : ',
								content:
									"Lieu d'envoi du produit (lieu où sera imprimé le ticket de fabrication). Par défaut, le point de fabrication pour tout nouveau produit est « Cuisine ».",
							},
							place_send_2: {
								title: 'Point de fabrication 2 : ',
								content:
									"Lieu d'envoi secondaire du produit (second lieu où sera envoyé le ticket de fabrication).",
							},
							status_send_index: {
								title: "Temps d'envoi : ",
								content:
									"Temps d'envoi du produit (Direct, Suite 1, Suite 2, Suite 3...). Par défaut, le temps d'envoi est fixé à « Direct » pour tout nouveau produit.",
							},
							supplements: {
								title: 'Suppléments : ',
								content:
									"Ici s'affichent les suppléments créées dans la rubrique « Suppléments ».",
								paragraph_1:
									"En cochant une ou plusieurs catégories de suppléments, un menu déroulant apparaitra sur la droite dans l'application lors de la prise de commande pour indiquer au serveur de renseigner les suppléments (par exemple ➔ plat : Entrecôte, suppléments : Cuisson, Accompagnement et/ou Sauce).",
								paragraph_2:
									'Ces suppléments peuvent être obligatoires ou facultatifs, ou avec un min/max pour les suppléments permettant de sélectionner plusieurs choix (voir la section « Suppléments » pour plus d’informations).',
							},
							color: {
								title: 'Couleur : ',
								content:
									'Couleur de la touche du produit dans la grille de prise de commande.',
							},
							exclusions: {
								title: 'Exclusions : ',
								content:
									'Cette fonctionnalité permet de choisir les salles dans lesquelles le produit n’apparaîtra pas sur la grille de commande.',
							},
						},
						paragraph_1_bold:
							'Pour enregistrer votre produit, cliquez sur le bouton bleu « Enregistrer » ',
						paragraph_1:
							"en haut à droite du formulaire. Si ce bouton est grisé, cela signifie qu'un des 3 champs obligatoires (nom, TVA ou type) n'est pas renseigné.",
						paragraph_2:
							"Si vous souhaitez qu'un produit soit disponible dans un menu mais non visible à la carte, créez une catégorie « Menu » dans laquelle vous classerez tous les produits de vos menus et excluez cette catégorie de toutes les salles. Une fois l'application installée, il vous suffira d'aller dans « Réglages / Options » et de cocher « Autoriser la sélection d'un produit non visible dans un menu ».",
					},
				},
				update: {
					title: 'Modifier un produit',
					paragraph_1:
						"Au sein du tableau de produits, vous pouvez modifier des informations d'un produit à la volée, en cliquant directement sur le champ d'un produit que vous souhaitez modifier dans la grille. Exemple : modification de couleur, nom, catégories...",
					paragraph_2:
						"Pour accéder au formulaire détaillé, cliquez sur l'icône de modification (picto crayon) en fin de ligne.",
				},
				cancel_update: {
					title: 'Annuler une modification',
					paragraph:
						"En haut à droite du tableau de l'ensemble des produits, figurent 2 flèches. Ces flèches permettent d'annuler la dernière modification faite (flèche vers la gauche) ou bien de revenir à une modification annulée (flèche vers la droite).",
				},
				reweight: {
					title: 'Organiser les produits dans la grille de commande',
					paragraph:
						"Les catégories de produits apparaissent en liste à gauche du tableau des produits. Cliquez sur une des catégories pour afficher uniquement les produits associés à une catégorie. Vous pouvez ainsi voir la façon dont s'afficheront les produits dans la grille de commande sur l'application.",
					list: {
						item_1:
							"Pour les réorganiser dans la grille, cliquez sur un des produits et faites-le glisser à l'endroit souhaité.",
						item_2:
							"Pour ajouter des espaces, cliquez sur le bloc gris « espace » et faites-le glisser à l'endroit souhaité. Les « espaces » sont des blocs vides dans le cas où vous voudriez fait une mise en forme spécifique.",
						item_3_1:
							"Pour ajouter un produit, cliquez sur le bloc gris « Assigner un produit » et faites-le glisser à l'endroit souhaité.",
						item_3_2:
							"Une fenêtre s'ouvre. Sélectionnez le ou les produits que vous souhaitez ajouter en cochant la case à droite de la ligne de produit. Le champ « chercher » vous permet de rechercher facilement un produit par son nom. Vous pouvez aussi chercher un produit dans une des catégories sur la gauche.",
						item_3_3:
							"Cliquez sur le bouton « Enregistrer » en haut à droite du formulaire. Le ou les produits ajoutés apparaissent alors en bas de votre grille. Vous pouvez le déplacer à l'endroit que vous souhaitez.",
						item_4:
							"Pour supprimer un produit d'une catégorie, passer la souris sur le bloc produit à supprimer et cliquez sur l'icône rouge de suppression qui apparaît en haut à droite du bloc. Le produit sera conservé dans la liste globale des produits mais n'appartiendra plus à aucune catégorie.",
						item_5:
							"Pour modifier un produit, cliquez sur le bloc du produit en question afin d'afficher le formulaire de modification.",
					},
				},
				filters: {
					title: 'Filtres',
					content:
						'Vous pouvez filtrer la liste des produits créés. Pour cela, plusieurs filtres sont proposés :',
					list: {
						search: {
							title: 'Rechercher : ',
							content: 'effectuer une recherche par nom de produit',
						},
						sort: {
							title: 'Tri : ',
							content:
								'trier par ordre des catégories, par ordre alphabétique de nom de produits ou bien par prix.',
						},
						add_filter: {
							title: 'Ajouter un filtre : ',
							content:
								'afficher uniquement les produits correspondant à une couleur, un prix, une TVA, un type, une catégorie ou bien un point de fabrication',
						},
					},
				},
			},
			category: {
				title: 'Catégories',
				paragraph_1:
					'Les catégories permettent d’organiser la carte en regroupant des plats ou des boissons selon la logique que vous souhaitez. Cette section permet de gérer les catégories dans lesquelles seront classés vos produits.',
				paragraph_2:
					'Pour créer une nouvelle catégorie, cliquez sur la croix rouge « + ».',
				paragraph_3:
					'Dans le formulaire à droite, renseignez le nom de la catégorie, sa couleur, son icône et éventuellement la ou les salles à exclure dans lesquelles cette catégorie ne sera pas proposée sur la grille de commande, puis cliquez sur « Enregistrer » en haut à droite du formulaire.',
				paragraph_4:
					"Vous pouvez réorganiser l'ordre des catégories créées. Pour cela, sélectionnez une des catégories en cliquant sur l'icône avec les 3 traits (à gauche de l'intitulé de la catégorie) et déplacez-la en la faisant glisser à l'endroit souhaité dans la liste.",
				paragraph_5:
					'Pour modifier une catégorie, cliquez sur celle que vous souhaitez modifier et changez les informations dans le formulaire à droite.',
				paragraph_6:
					"Pour supprimer une catégorie, cliquez sur l'icône « supprimer » en fin de ligne. Si des produits sont associés à la catégorie supprimée, les produits seront conservés mais n'appartiendront plus à aucune catégorie.",
				paragraph_7:
					"Si vous souhaitez qu'un produit soit disponible dans un menu mais non visible à la carte, créez une catégorie « Menu » dans laquelle vous classerez tous les produits de vos menus et excluez cette catégorie de toutes les salles. Une fois l'application installée, il vous suffira d'aller dans « Réglages / Options » et de cocher « Autoriser la sélection d'un produit non visible dans un menu ».",
			},
			supplement: {
				title: 'Supplément',
				paragraph_1:
					'Cette section regroupe tout ce qui peut être ajouté (gratuitement ou non, et obligatoirement ou non) à un produit. Ces suppléments sont regroupés par catégories de suppléments (ex : Cuisson) et des suppléments peuvent être associées à chacune de ces catégories (ex : saignant, à point...).',
				create: {
					title: 'Créer une catégorie de de supplément',
					paragraph_1:
						'Pour créer une catégorie de supplément, cliquez sur le bouton "Ajouter une catégorie de supplément".',
					list: {
						name: {
							title: 'Nom de la catégorie de supplément : ',
							content:
								'Libellé de la catégorie de supplément. Privilégiez un nom court.',
						},
						required: {
							title: 'Obligatoire : ',
							content:
								"cochez cette coche si vous souhaitez que l'option soit obligatoire lorsqu'elle sera attribuée à un produit. Si un supplément est paramétré comme étant obligatoire, le serveur ne pourra pas envoyer la commande en fabrication tant qu’il n’aura pas saisi le nombre de suppléments attendus.",
							paragraph:
								"Vous pouvez laisser cette option décochée par défaut et la cocher plus tard au cas par cas dans le formulaire des produits auxquels vous l'associerez. Ainsi, cette option pourra être obligatoire pour certains produits, et facultative pour d'autres.",
						},
						type: {
							title: 'Type : ',
							content: 'Il existe 3 types de suppléments : ',
							list: {
								unique: {
									title: 'Un seul choix ',
									content:
										'permet de sélectionner un seul supplément lors de la commande : une cuisson pour une viande par exemple.',
								},
								multiple: {
									title: 'Plusieurs choix ',
									content:
										'permet de sélectionner plusieurs suppléments mais en quantité unique : le client désire une salade et des frites en accompagnement par exemple.',
								},
								multiple_quantity: {
									title: 'Plusieurs choix en quantité ',
									content:
										'permet de sélectionner plusieurs suppléments en quantité X : le client désire 2 boules de glace vanille et 1 boule de glace chocolat, vous pourrez donc cliquer deux fois sur vanille et une fois sur chocolat.',
								},
							},
							description: {
								paragraph_1:
									'En fonction du type de supplément, le caractère obligatoire ou non se présentera différemment :',
								list: {
									unique: {
										title: '« Un seul choix » : ',
										content:
											'si l’option « Obligatoire » est activée, le serveur devra saisir un seul supplément dans la commande. Sinon, la saisie du supplément est facultative.',
									},
									multiple: {
										title:
											'« Plusieurs choix » ou « Plusieurs choix en quantité » : ',
										content:
											'pour ces deux types, il est possible de paramétrer un nombre minimum et maximum de supplément(s) à saisir. ',
									},
								},
								paragraph_2:
									'Par exemple pour une glace avec 3 boules obligatoires, il faudra indiquer min : 3 / max 3. Si le nombre est "0", la saisie minimum et/ou maximum devient facultative, le serveur pourra sélectionner autant de boules de glace qu\'il souhaite, ou bien aucune.',
								paragraph_3:
									'Vous pouvez laisser min 0 et max 0 par défaut et le préciser plus tard au cas par cas dans le formulaire des produits auxquels vous associerez ce supplément. Ainsi, ce supplément pourra avoir des min/max différents pour chaque produit.',
							},
						},
						icon_color: {
							title: 'Icône et couleur : ',
							content:
								"Choisissez l'icône et la couleur qui représentera la catégorie de supplément dans la prise de commande.",
						},
						exclusions: {
							title: 'Exclusions : ',
							content:
								'Cette fonctionnalité permet de choisir les salles dans lesquelles la catégorie de supplément n’apparaîtra pas lors de la commande. ',
						},
					},
					paragraph_2:
						'Pour modifier une catégorie de supplément créée, cliquez sur l’icône de modification (le crayon).',
				},
				reweight: {
					title: 'Ordre des suppléments',
					paragraph:
						"Vous pouvez réorganiser l'ordre des catégories de supplément créées. Pour cela, sélectionnez une des catégories en cliquant sur l'icône avec les 3 traits (à gauche de l'intitulé de la catégorie) et déplacez-la vers le haut ou le bas en la faisant glisser à l'endroit souhaité dans la liste.",
				},
				supplements: {
					title: "Définir les suppléments d'une catégorie",
					paragraph_1:
						'Vous pouvez ajouter autant de supplément que vous souhaitez à une catégorie',
					paragraph_2:
						"Pour cela, sélectionnez la catégorie de supplément (cliquez sur la ligne de l'intitulé de la catégorie) et cliquez sur « Ajouter supplément » dans la partie droite. Dans le formulaire qui apparait, indiquez le nom du supplément, sa couleur, les salles éventuelles à exclure et enregistrez.",
					paragraph_3:
						"Pour un supplément payant, saisissez le montant du supplément (montant qui s'ajoutera au montant initial du produit).",
					paragraph_4:
						"Les suppléments sont présentées en grille de façon similaire à celles que vous retrouverez sur la prise de commande de l'application. Vous pouvez déplacer chaque bloc en cliquant dessus et en le faisant glisser à l'endroit souhaité.",
					paragraph_5:
						'Pour ajouter un espace, cliquez sur le bouton « ajouter un espace ». Les "ESPACES" sont des espaces vides dans le cas ou vous voudriez faire une mise en forme spécifique.',
				},
				associate: {
					title: 'Attribuer une catégorie de supplément à un produit',
					paragraph:
						"Il existe 2 façons d'attribuer une catégorie de supplément à des produits :",
					list: {
						item_1:
							"1 / Cliquez sur l'icône « Assigner des produits » (bloc note) et cochez les produits auxquels vous souhaitez associer ce supplément.",
						item_2:
							'2 / Vous pouvez également associer le supplément directement depuis la section « Supplément » au sein du formulaire du produit souhaité (dans la rubrique « Produits »).',
					},
				},
			},
			patchMenu: {
				title: 'Patches / Déploiements',
				create: {
					title: 'Qu’est-ce qu’un patch ?',
					paragraph_1:
						"Lorsque vous accédez à une carte sur la carte web, un « patch » est automatiquement créé. Un patch est un ensemble de modifications pour lesquelles vous pouvez choisir la date à laquelle il sera déployé sur l'application.",
					paragraph_2:
						'Un patch est automatiquement créé lorsque vous accédez à une carte sur la carte Web, même si aucune modification n’est en cours sur cette carte. Par défaut, le nom du patch est intitulé « Modifications » suivi de la date à laquelle le patch a été initialisé. Vous pouvez modifier son nom en cliquant sur le picto crayon à côté du nom du patch (en haut de l’écran, lorsque vous accédez à votre carte).',
					paragraph_3:
						"Vous pouvez modifier votre carte à volonté depuis la carte web. Tant que le déploiement n'aura pas été programmé, les modifications de votre patch ne seront pas disponibles sur l'application.",
				},
				deploy: {
					title: 'Déploiements',
					paragraph_1:
						'Lorsque les modifications de votre carte sont terminées, vous devez créer un déploiement pour les rendre accessibles sur l’application. Le déploiement peut être effectué de 2 façons: ',
					paragraph_2:
						'Soit en cliquant sur la rubrique « Déploiement » de la barre de navigation à gauche, lorsque vous êtes sur une carte: ',
					paragraph_3:
						"Soit en cliquant sur l'icône de calendrier sur l'écran de gestion de cartes (accessible depuis le menu en haut à droite): ",
					paragraph_4:
						'Vous accédez alors au formulaire de déploiement avec deux informations à renseigner: ',
					paragraph_5: 'Nom du déploiement: ',
					paragraph_6: `Vous pouvez modifier son nom en cliquant sur le champ « Nom de la modification ». Le nom est obligatoire. Vous retrouverez ce nom dans l’historique des déploiements sur l’iPad, dans la rubrique « Carte ».`,
					paragraph_7: 'Date du déploiement: ',
					paragraph_8: 'Vous pouvez choisir de déployer: ',
					paragraph_9:
						'immédiatement : dans ce cas, les modifications seront disponibles sur l’iPad lors de la prochaine synchronisation (voir paragraphe suivant)',
					paragraph_10:
						"ou bien à une date ultérieure. Pour cela, cliquez sur « Déployer ultérieurement à la date », puis cliquez sur le champ « Date du déploiement » et choisissez le jour et l'heure du déploiement. Les modifications seront disponibles sur l’application seulement à partir du moment où une synchronisation sera faite à partir de cette date sera atteinte.",
					paragraph_11:
						'Cliquez ensuite sur « Valider » pour valider le déploiement.',
					paragraph_12:
						'Synchronisation des modifications de carte sur l’application',
					paragraph_13:
						'Une fois le déploiement validé sur la Carte Web, la nouvelle carte ne sera pas immédiatement activée sur l’iPad. Vous pouvez donc faire un déploiement à tout moment de la journée, sans crainte de remplacer une carte en plein service. Les modifications seront disponibles sur l’application seulement à la prochaine synchronisation de l’application.',
					paragraph_14:
						'Une synchronisation peut s’effectuer de 2 façons, si votre iPad est connecté au réseau Wifi internet: ',
					paragraph_15:
						'De manière « automatique » : Effectuez une clôture de service puis une ouverture de service',
					paragraph_16:
						'De manière « forcée » : Aller dans « Réglages / A propos » depuis l’iPad maître et cliquer sur le bouton « Synchro manuelle »',
					paragraph_17:
						'Dans ces deux cas, un message s’affichera alors vous informant que des modifications de carte ont été effectuées. Vous pouvez cliquer sur « Oui » pour les accepter, ou bien sur « Non » pour les appliquer ultérieurement (Voir section suivante pour activer une nouvelle carte).',
					paragraph_18:
						'A partir de ce moment, l’accès à la carte sur la Carte Web est momentanément bloqué. Pour y accéder de nouveau, il faut de nouveau effectuer une clôture de service ou bien une synchronisation manuelle.',
					paragraph_19: 'Pour résumer: ',
					paragraph_20:
						'Déploiement depuis la Carte web = Envoi des modifications vers l’application, mais modifications non appliquées sur iPad. Dans le cas d’un déploiement immédiat, la carte sera en statut « Non synchronisé ». Cette information est visible sur le bloc récapitulatif de votre carte, dans la rubrique “Gestion des cartes” (accessible depuis le menu en haut à droite) A ce stade vous pouvez toujours accéder à la carte et effectuer d’autres déploiements à des dates ultérieures.',
					paragraph_21:
						'Synchronisation sur l’Application depuis l’iPad maître = Réception des modifications et blocage de l’accès à la carte sur la Carte Web. A ce stade, la carte passe en statut « Synchronisé non appliqué » sur l’interface web.',
					paragraph_22:
						'Nouvelle synchronisation sur l’Application depuis l’iPad = Déblocage de l’accès à la carte web. A ce stade, la carte passe en statut « Synchronisé ».',
					paragraph_23: 'Appliquer les modifications: ',
					paragraph_24: 'Modification d’une carte existante: ',
					paragraph_25:
						'Dans le cas où des modifications sont effectuées sur la carte qui est active sur l’iPad, alors, une fois le déploiement effectué et la synchronisation faite sur iPad, un message indiquera que des modifications ont été faites sur la carte. En cliquant sur « Oui », les modifications seront immédiatement mises à jour sur la carte active.',
					paragraph_26:
						'Si vous ne souhaitez pas les appliquer tout de suite, cliquez sur « Non ». Vous pourrez les appliquer plus tard en vous rendant dans l’historique des cartes (voir ci-dessous « Consulter les différentes cartes sur iPad »).',
					paragraph_27: 'Création d’une nouvelle carte: ',
					paragraph_28:
						'Dans le cas où une toute nouvelle carte est déployée, différente de la carte qui est active sur l’iPad, alors après déploiement et synchronisation sur iPad, un message indiquera qu’une nouvelle carte est disponible. En cliquant sur le nom de la carte, celle-ci sera récupérée mais pas tout de suite activée. Vous devrez aller dans l’historique des cartes pour l’activer (voir ci-dessous « Consulter les différentes cartes sur iPad »)',
					paragraph_29:
						'Consulter les différentes cartes sur iPad et appliquer les modifications en attente',
					paragraph_30:
						'La liste de vos cartes et de leurs déploiements peut être consultée sur iPad dans la rubrique « Réglages / Carte » : un bouton en haut à droite mentionne le nom de votre carte actuellement active. Cliquez dessus pour accéder à la liste des différentes cartes que vous avez déployées: ',
					paragraph_31:
						'La coche bleue sous l’intitulé d’une carte indique la carte actuellement activée sur votre application. Pour activer une autre carte, il suffit de cliquer sur la coche d’une autre carte, puis de cliquer sur « Valider ».',
					paragraph_32:
						'Pour consulter l’historique des différents déploiements effectués sur une même carte, cliquez sur le bouton bleu « Modifié le XX/XX/XXXX (Voir) ». Vous accédez alors à l’historique des déploiements effectués sur la carte en question.',
					paragraph_33:
						'Le cercle bleu avec un numéro vous permet d’avoir des informations sur les modifications importantes effectuées.',
					paragraph_34:
						'Dans le cas de modifications de carte mises en attente, c’est-à-dire que vous n’avez pas souhaité appliquer immédiatement, ou bien d’une nouvelle carte que vous n’avez pas acceptée immédiatement, un bouton orange s’affichera alors sous la carte: ',
					paragraph_35:
						'Cliquez dessus pour appliquer les modifications. Dans le cas d’une nouvelle carte, vous devrez en plus cocher la coche bleue pour réellement activer la carte.',
					paragraph_36: 'Supprimer un déploiement programmé',
					paragraph_37:
						"Sur la Carte Web, dans la section « Gérer les déploiements », les patchs dont le déploiement est programmé à une date ultérieure sont visibles dans l'ordre chronologique. Il est possible de supprimer un patch à venir à condition qu'il soit programmé dans plus de 24 heures. Il est possible de supprimer uniquement le dernier patch à venir. S’il y en a plusieurs à venir, vous pourrez donc les supprimer un à un.",
					paragraph_38:
						'Modifier la carte sur iPad et synchroniser avec la Carte web',
					paragraph_39:
						'Si vous effectuez une modification de carte depuis l’iPad, cette modification sera prise en compte dans la Carte Web lors de la prochaine synchronisation manuelle ou clôture de service.',
					paragraph_40:
						'Il est possible de modifier la carte depuis la Carte Web et de faire des modifications en même temps sur l’iPad. Lors de la prochaine synchronisation, l’ensemble des modifications seront réunies. Cependant, la Carte Web a toujours la priorité sur les modifications par rapport aux modifications faites sur l’iPad : si vous modifiez les mêmes champs, les modifications effectuées depuis la Carte Web viendront écraser les données concernées sur l’iPad.',
					paragraph_41:
						'Par exemple : sur la Carte web, vous avez passé le prix d’un produit à 10€. En parallèle, depuis l’iPad, vous passez le prix de ce même produit à 12€, mais vous ne faites pas de synchronisation. Lors du prochain déploiement suivi d’une synchronisation, le prix que vous avez défini depuis la Carte Web (10€) sera appliqué dans l’application.',
				},
			},
			menu: {
				title: 'Menus',
				paragraph:
					"Pour ajouter un nouveau menu, cliquez sur l'icône rouge « + ». La création d'un menu s'effectue en 4 étapes. A la fin de chaque étape, cliquez sur « suivant » pour passer à l'étape suivante :",
				denomination: {
					title: '1 / Dénomination',
					list: {
						name: {
							title: 'Nom du menu : ',
							content:
								"(champ obligatoire) Libellé du menu utilisé par défaut dans l'application",
						},
						short_name: {
							title: 'Nom court :  ',
							content:
								'Libellé du menu utilisé si l’option est activée dans la grille de produits durant la prise de commande et/ou sur les impressions (en cuisine et le ticket de caisse).',
						},
						sku: {
							title: 'SKU : ',
							content:
								'Si vous avez plusieurs établissements et des menus communs mais qui n’ont pas le même nom, entrez un code commun pour ce menu.',
						},
						description: {
							title: 'Description : ',
							content:
								'Description ou commentaire du menu. Accessible lors de la prise de commande.',
						},
						active: {
							title: 'Actif : ',
							content:
								'Rendre le menu visible ou non dans la prise de commande (en cas de menu non disponible temporairement ou saisonnier)',
						},
						color: {
							title: 'Couleur du Menu : ',
							content:
								'Couleur de la touche du menu dans la grille de prise de commande.',
						},
					},
				},
				prices_exclusions: {
					title: '2 / Prix et exclusions',
					list: {
						exclusions: {
							title: 'Exclusions : ',
							content:
								'Cette fonctionnalité permet de choisir les salles dans lesquelles le produit n’apparaîtra pas sur la grille de commande.',
						},
						prices: {
							title: 'Prix :  ',
							content: 'Prix TTC du Menu',
							paragraph:
								"Si vous définissez des catégories de prix (ex : Happy hour), dans la rubrique « Catégories de prix », les catégories de prix apparaissent sous le prix TTC du menu. Vous pouvez choisir d'attribuer ou non la catégorie de prix à ce menu et de définir le prix pour le menu en question.",
						},
					},
				},
				products: {
					title: '3 / Gestion des produits',
					paragraph_1:
						'Cette étape vous permet de définir les différents niveaux du menu et les produits attribués à chaque niveau.',
					paragraph_2:
						'Par défaut, 2 niveaux sont prédéfinis : « Entrée » et « Plat ».',
					list: {
						item_1:
							"Pour ajouter un nouveau niveau, cliquez sur « Ajouter un niveau de menu ». Renseignez le nom du niveau (ex : Dessert ») et l'icône associée, et enregistrez.",
						item_2_1:
							'Pour modifier leur intitulé et leur attribuer une icône, cliquez sur le picto de modification (le crayon).',
						item_2_2:
							'Vous pouvez rendre un niveau de menu « facultatif » en cochant la coche « Facultatif ». Lors de la prise de commande, le menu pourra être envoyé sans sélectionner de produit dans ce niveau.',
						item_2_3:
							'Par exemple pour un menu Entrée/Plat et Plat/dessert au même prix, vous pouvez créer 3 niveaux de menu (Entrée/plat/dessert) et rendre les niveaux « Entrée » et « dessert » facultatifs.',
						item_3:
							"Pour supprimer un niveau, cliquez sur la croix près de l'intitulé du niveau de menu.",
						item_4:
							"Pour réorganiser les niveaux, sélectionnez un des niveaux et déplacez-le vers le haut ou vers le bas à l'endroit souhaité.",
						item_5:
							"Pour ajouter des produits à un niveau, cliquez sur le bloc gris « + produit ». Une fenêtre s'ouvre alors. Pour sélectionner le ou les produits que vous souhaitez ajouter, cochez la case à droite de la ligne de produit. Le champ « Chercher » vous permet de rechercher facilement un produit par son nom. Vous pouvez aussi chercher un produit dans une des catégories sur la gauche.",
					},
					paragraph_3:
						'Cliquez sur le bouton « Enregistrer » en haut à droite du formulaire.',
					paragraph_4:
						'Le ou les produits ajoutés apparaissent alors dans la grille du niveau de menu.',
					paragraph_5:
						"Vous pouvez réorganiser leur ordre : pour cela, cliquez sur un produit et déplacez-le à l'endroit souhaité.",
				},
				validation: {
					title: '4 / Validation',
					content:
						'Cette étape vous permet de vérifier les informations du menu avant de valider.',
				},
			},
			priceCategory: {
				title: 'Catégories de prix (Multiprix)',
				paragraph:
					'Les catégories de prix servent à attribuer plusieurs prix à un même produit afin de gérer par exemple des happy hours, des prix à emporter ou des prix terrasse. Vous pouvez en effet créer autant de prix que nécessaire !',
				create: {
					title: 'Créer une catégorie de prix',
					paragraph_1:
						'Pour créer une nouvelle catégorie, cliquez sur la croix « + » rouge pour afficher le formulaire.',
					list: {
						title: 'Remplissez les champs suivants :',
						name: {
							title: 'Nom : ',
							content:
								'Libellé de la catégorie de prix utilisé par défaut dans l’application.',
						},
						short_name: {
							title: 'Nom court : ',
							content:
								'Libellé court de la catégorie de prix qui s’affichera à côté du nom du produit / menu / supplément aux endroits listés ci-dessous si les options correspondantes sont activées :',
							list: {
								item_1:
									'Affichage du nom court en commande : le nom court de la catégorie s’affichera dans la grille de commande',
								item_2:
									'Affichage du nom court à l’encaissement : le nom court de la catégorie s’affichera dans l’écran d’encaissement et également sur les tickets de caisse',
								item_3:
									'Affichage du nom court en fabrication : le nom court de la catégorie s’affichera sur les bons de fabrication ',
							},
						},
						active: {
							title: 'Actif : ',
							content:
								'Cet interrupteur sert à activer ou désactiver la catégorie de prix, pour pouvoir la réutiliser ultérieurement sans la supprimer.',
						},
						duration: {
							title: 'Durée : ',
							content:
								' « Journée entière ou horaires » : si la catégorie de prix doit être utilisable toute la journée, laissez l’interrupteur « Journée entière » activé, sinon désactivez-le pour accéder aux horaires, et définir une heure de début ainsi qu’une heure de fin de validité de la catégorie. L’heure de fin peut très bien être définie le lendemain, par exemple de 19:00 à 02:00 le lendemain.',
						},
						days: {
							title: 'Jours : ',
							content:
								'Ce champ sert à sélectionner les jours pendant lesquels la catégorie de prix sera active. S’il n’y a pas de distinction à faire, laisser «Tous les jours».',
						},
						floors: {
							title: 'Salles : ',
							content:
								'Ce champ sert à sélectionner les salles dans lesquelles la catégorie de prix sera active. S’il n’y a pas de distinction à faire, laissez la sélection par défaut.',
						},
					},
					paragraph_2:
						'Cliquez sur « Enregistrer » une fois les paramètres définis.',
				},
				config: {
					title: 'Configurer des prix',
					paragraph_1:
						'Il existe trois façons de configurer les prix de votre catégorie de prix :',
					list: {
						item_1: 'Configuration rapide',
						item_2: 'Copie intégrale de catégorie de prix',
						item_3: 'Configuration manuelle produit par produit',
					},
					paragraph_2_1:
						'Lorsque vous avez créé votre catégorie de prix, cliquez sur la catégorie créée pour afficher de nouveau le formulaire : les boutons ',
					paragraph_2_2: "« Copier à partir d'une autre catégorie »",
					paragraph_2_3: ' et ',
					paragraph_2_4: '« Configuration rapide » ',
					paragraph_2_5: 'sont devenus actifs.',
					fast: {
						title: '1 / Configuration rapide : ',
						paragraph_1:
							'Le bouton « Configuration rapide » sert à paramétrer rapidement des prix sur les produits de votre carte (uniquement les produits, et non pas les menus ou suppléments).',
						paragraph_2:
							'Cliquer sur le bouton pour faire apparaître la fenêtre de configuration rapide.',
						paragraph_3:
							'Dans cette fenêtre sont listées toutes les catégories de produits de votre carte.',
						paragraph_4:
							'Pour chaque catégorie souhaitée, sélectionnez un des calculs disponibles pour paramétrer les prix liés à la catégorie de prix :',
						list: {
							no_changes: {
								title: 'Aucun changement : ',
								content:
									'laissez ainsi si vous ne souhaitez pas appliquer la catégorie de prix à cette catégorie de produit.',
							},
							fixed_price: {
								title: 'Prix fixe : ',
								content:
									'appliquer le même prix sur tous les produits des catégories sélectionnées.',
							},
							price_plus: {
								title: 'Montant en plus : ',
								content:
									'ajouter un montant déterminé au prix par défaut de chacun des produits des catégories sélectionnées',
							},
							price_minus: {
								title: 'Montant en moins : ',
								content:
									'enlever un montant déterminé au prix par défaut de chacun des produits des catégories sélectionnées',
							},
							percent_plus: {
								title: '% en plus : ',
								content:
									'ajouter un pourcentage au prix par défaut de chacun des produits des catégories sélectionnées (par exemple 50%) ',
							},
							percent_minus: {
								title: '% en moins : ',
								content:
									'enlever un pourcentage au prix par défaut de chacun des produits des catégories sélectionnées',
							},
							reinit: {
								title: 'Réinitialiser : ',
								content:
									'cette fonctionnalité permet de supprimer les paramètres de catégorie de prix  sur tous les produits des catégories sélectionnées.',
							},
						},
						paragraph_5:
							'Sélectionnez un des choix, renseignez un montant ou un pourcentage si besoin, puis validez. Vous pouvez définir des règles différentes selon vos catégories de produits.',
						paragraph_6:
							'Après avoir cliqué sur « Valider », une fenêtre s’affiche pour confirmer le paramétrage des prix. Cliquez sur « Oui » pour confirmer. ',
						paragraph_7:
							'Pour vérifier que les prix de la catégorie de prix ont bien été sauvegardés,  cliquez sur le picto gris « i » sur la ligne de la catégorie de prix. Vous verrez apparaître à côté de chaque produit deux prix : le prix par défaut, ainsi que le prix de la catégorie prix qui vient d’être paramétrée.',
					},
					integral: {
						title: '2 / Copie intégrale :',
						paragraph_1_1: 'Le bouton ',
						paragraph_1_2: "« Copier à partir d'une autre catégorie » ",
						paragraph_1_3:
							"sert à copier l'intégralité des prix déjà paramétrés d'une catégorie de prix (produits, menus, suppléments) vers une autre.",
						paragraph_2:
							"Pour se faire, après avoir créé une catégorie de prix, affichez de nouveau le formulaire de la catégorie de prix et cliquez sur le bouton « Copier à partir d'une autre catégorie ». Une fenêtre s’affiche avec la liste des catégories de prix déjà existantes. Cliquez sur la catégorie dont vous voulez copier l’intégralité des prix, puis confirmez la copie.",
						paragraph_3:
							'Pour vérifier que la copie des prix de la catégorie de prix a bien eu lieu, même principe que pour la configuration rapide : cliquez sur le picto gris « i » sur la ligne de la catégorie de prix. Vous verrez apparaître à côté de chaque produit deux prix : le prix par défaut, ainsi que le prix de la catégorie prix qui vient d’être paramétré.',
					},
					by_product: {
						title:
							'3 / Configuration manuelle par produit / menu / supplément :',
						paragraph_1:
							'Pour configurer les prix d’une catégorie de prix sur chacun des produits ou menus, rendez-vous dans la rubrique « Produits » ou « Menus ».',
						paragraph_2:
							"La ou les catégories de prix que vous avez créées apparaissent dans la section « Prix » dans le formulaire d'un produit ou d'un menu.",
						paragraph_3:
							'Cochez la catégorie de prix que vous souhaitez activer et indiquez son prix.',
						paragraph_4:
							'Pour les suppléments,  rendez-vous dans la rubrique « Supplément ». Sélectionnez la catégorie de supplémentde votre choix et cliquez sur une des suppléments associées. La ou les catégories de prix que vous avez créées apparaissent dans la section « Prix ».',
					},
				},
			},
			tax: {
				title: 'TVA',
				paragraph_1_1: 'Trois TVAs sont pré-configurées : ',
				paragraph_1_2: '10% ',
				paragraph_1_3: 'pour la nourriture et les boissons non alcoolisées, ',
				paragraph_1_4: ' 10% / 5,5% ',
				paragraph_1_5:
					'pour gérer les produits vendus « sur place » et « à emporter » et qui sont assujettis à la taxe 5,5%, et enfin ',
				paragraph_1_6: '20% ',
				paragraph_1_7: 'pour les produits alcoolisés.',
				paragraph_2:
					"Il est possible de modifier ces TVA en cliquant dessus et en modifiant le formulaire qui s'affiche sur le côté droit.",
				note: {
					title: 'A noter : ',
					content_1:
						'si on change un taux, tous les produits qui sont liés à ce taux seront ',
					content_2: 'impactés.',
				},
				paragraph_3:
					"La TVA à 10% est attribuée par défaut lors de la création d'un nouveau produit. Pour définir une autre TVA par défaut, cliquez sur une des TVA, cochez « par défaut » dans la partie de droite et enregistrez.",
				create: {
					title: 'Créer une nouvelle TVA :',
					paragraph_1:
						'Pour ajouter une nouvelle TVA, cliquez sur le picto rouge « + » et remplissez les champs présents sur le côté droit.',
					paragraph_2:
						'Pour une même TVA il est possible de configurer des taux différents pour le service sur place et à emporter.',
				},
				delete: {
					title: 'Supprimer une TVA :',
					paragraph_1: 'Seules les TVA non actives peuvent être supprimées',
					paragraph_2:
						"Pour supprimer une TVA, il faut donc au préalable réaffecter l’ensemble des produits attribués à cette TVA, puis la rendre inactive (pour cela cliquez sur l'intitulé de la TVA et décochez « actif »).",
					paragraph_3:
						'Une fois définie comme inactive, un picto de suppression apparaît sur la ligne de la TVA. Cliquez dessus pour la supprimer.',
					note: {
						title: 'A noter : ',
						content:
							'une TVA définie « par défaut » ne peut pas être supprimée.',
					},
					paragraph_4:
						'Si un doute subsiste sur le taux de TVA à appliquer sur certains produits, il est recommandé de vous rapprocher de votre comptable qui pourra indiquer le bon taux à appliquer. ',
				},
			},
			master: {
				title: 'Master Multi-établissements',
				presentation: {
					title: 'Présentation des fonctionnalités',
					p1_1: 'Gestion Multi-Établissements à distance - Interface web / Connexion',
					p1_2: 'Depuis un navigateur web, il est nécessaire de se connecter à l’adresse menu.laddition.com et d’utiliser les identifiants correspondants au compte « Master Carte» de vos établissements.',
					p2_1: 'Modifications centralisées, par zone ou par établissement',
					p2_2: 'Selon les règles définies (voir après) il est possible de gérer les modifications de carte en centralisé (mode « siège») par zone ou par site',
					p3_1: 'Programmation en avance des modifications de carte',
					p3_2: 'Il est possible d’utiliser le calendrier disponible afin de programmer des modifications de carte. Il est possible de créer ou retirer des produit en avance, de changer les prix',
					p3_3: 'ATTENTION',
					p3_4: 'Si vous changez l’un de ces champs à une date ultérieure, le changement s’appliquera le jour où vous l’avez changé et déployé. En effet, il est recommandé de créer un nouveau produit plutôt que changer son nom. D’un point de vu statistiques des ventes, cela sera bénéfique car le produit en question pourra être sélectionné (dans les produits invisibles ou supprimés).',
					p3_5: 'Nom du produit + Nom court',
					p3_6: 'SKU',
					p3_7: 'Couleur',
					p3_8: "Lieu d'envoi",
					p4_1: 'Reporting optimisé pour l’analyse des ventes',
					p4_2: 'En plus des rapports existants par établissement, certains rapports d’analyse sont disponibles au niveau « multi-établissements » comme par exemple : ',
					p4_3: 'Comparaison d’établissements',
					p4_5: 'Analyse produits groupée (Mise en place de SKU obligatoire)',
					p4_6: 'Synthèse des paiements ',
					p4_7: 'Etc...',
					p4_8: 'Pour plus d’informations sur le reporting, voir le manuel utilisateur du reporting.',
				},
				synchro: {
					title: 'LES REGLES DE SYNCHRONISATION',
					p1: 'Toutes les caractéristiques marquées d’une coche sur les captures ci-après peuvent être centralisées ou personnalisables par site. Lorsqu’il y a une flèche à double sens, cela signifie que l’ordre des éléments peut également  être centralisé ou personnalisable par site.',
					p2: 'LES PRODUITS',
					p3: 'LES CATEGORIES DE PRODUITS',
					p4: 'LES CATÉGORIES DE SUPPLÉMENTS ET SUPPLEMENTS',
					p5: 'LES SUPPLEMENTS ASSIGNES AUX PRODUITS',
				},
				deploy: {
					title: 'LES DEPLOIEMENTS',
					p1_1: 'CHOIX DU SITE OU DE LA ZONE CONCERNES',
					p1_2: 'Le déploiement peut se faire par zone ou par site. Il faut s’assurer du site ou de la zone choisie avant de déployer en cliquant sur l’icône « bonhomme » sur le menu à gauche de l’écran et choisissez la zone ou le site sur lequel vous souhaitez déployer. S’affiche alors une nouvelle icône dont la siginification est détaillée ci-après.',
					p1_3: 'Une fois les modifications effectuées, il faut aller dans l’onglet « déploiement » en bas du menu sur la gauche de l’écran. Les changements sont conservés automatiquement même sans déployer si vous décidez de ne pas envoyer les modifications sur les caisses immédiatement',
					p1_3_1: '-> Mode siège (pas de déploiement possible)',
					p1_3_2: '-> Zone',
					p1_3_3: '-> Site',
					p1_4: 'Une fois sur la page de déploiement, vous trouverez les informations suivantes : ',
					p1_4_1: '1 - La date concernée pour les changements',
					p1_4_2: '2 - Le site ou la zone concernés ',
					p1_4_3:
						'3 - Le nom personnalisable des modifications (initialement la date du jour pré-remplie)',
					p1_4_4: '4 - Le bouton de déploiement',
					p1_5: 'ATTENTION :',
					p1_5_1:
						'Bouton bleu = Des modifications n’ont pas encore été déployées',
					p1_5_2: 'Bouton gris = Pas de modification à déployer',
					p1_6: 'Après avoir cliqué sur le bouton « déployer», vous vous retrouverez sur la page récapitulative du déploiement effectué. Vous pouvez sélectionner un nouveau site ou une nouvelle zone pour poursuivre les déploiements si nécessaire.',
					p2: 'COMMENT LES ETABLISSEMENTS PEUVENT RECUPERER LES MODIFICATIONS DE CARTE APRES DEPLOIEMENT',
					p2_1: 'RECUPERATION « MANUELLE» DES MODIFICATIONS',
					p2_2: "Après le déploiement de la carte, chaque établissement doit synchroniser l'iPad principal (soit de manière automatique lors de l'ouverture/clôture d'un service, soit de manière « forcée » : aller dans « Réglages / A propos » depuis l’iPad et cliquer sur le bouton « Synchro manuelle »)",
					p2_3: "L'application alerte que des modifications peuvent être apportées sur la carte, dans la fenêtre il faut cliquer sur le bouton « Oui» afin de récupérer la carte master qui sera commune à tous les établissements.",
					p2_4: 'Lorsque les modifications sont récupérées, l’application indique que « Les modifications ont été effectuées avec succès».',
					p3: 'RECUPERATION « AUTOMATIQUE» DES MODIFICATIONS',
					p3_1: 'Avec un paramétrage spécifique, il est possible de mettre en place la récupération automatique des modifications de carte à partir du moment que la tablette maître est connectée à Internet, que le service est ouvert et que l’application est en premier plan.',
					p3_2: 'Pour cela il est nécessaire de faire parvenir un mail à integration@laddition.com',
					p3_3: 'A ce moment, lorsque le déploiement est effectué, une notification s’affiche sur l’iPad Maître pour indiquer que « des modifications de carte ont été appliquées » (il suffit de faire glisser la notification vers la gauche pour la supprimer).',
				},
			},
		},
	},
	save: 'Enregistrer',
	confirmation: 'Confirmation',
	validate: 'Valider',
	cancel: 'Annuler',
	remove: 'Supprimer',
	ipad_view: 'VUE CAISSE',
	ipad_view_readonly: 'Données actuelles (hors modification en cours)',
	ipad_view_no_register: 'Pas de caisse au siège ni en zone : sélectionnez un établissement',
	ipad_view_loading: 'Chargement des données de la caisse…',
	ipad_view_source_empty: 'Rien sur la caisse pour cet élément',
	ipad_view_source_error: 'Impossible de charger les données de la caisse',
	category_changes: {
		button: 'Modifications en cours',
		title: 'Modifications en cours de la catégorie : brouillon / caisse',
		loading: 'Comparaison avec la caisse…',
		error: 'Impossible de comparer avec la caisse',
		none: 'Aucune modification en cours pour cette catégorie',
		unchanged: 'Aucune différence avec la caisse',
		draft: 'Brouillon (après)',
		diff: 'Ce qui change',
		caisse: 'Caisse (avant)',
		replay: 'Rejouer',
		added: 'NOUVEAU',
		was_case: 'était %{n}',
		legend_added: 'ajouté',
		legend_moved: 'déplacé (case caisse → case brouillon)',
		legend_removed: 'retiré',
		cancel: 'Supprimer les modifications en cours',
		cancel_confirm: 'Le brouillon de la catégorie revient à la caisse. Confirmer ?',
		cancel_yes: 'Supprimer',
		cancel_no: 'Annuler',
		cancel_error: 'La suppression a échoué',
		mode_grid: 'Grille',
		mode_ipad: 'iPad',
		title_supplement: 'Modifications en cours de la catégorie de suppléments : brouillon / caisse',
		origin_master: 'Les modifications proviennent des règles de synchronisation master/site',
		origin_local: 'Les modifications proviennent de changements locaux',
		origin_import: "Les modifications proviennent de l'import Excel",
		title_menu: 'Modifications en cours du menu : brouillon / caisse',
		level_moved: 'niveau %{from} → %{to}',
		legend_changed: 'prix ou obligatoire modifié',
		required: 'obligatoire',
		optional: 'facultatif',
	},
	edit: 'Modifier',
	close: 'Fermer',
	warning: 'Attention',
	notification: {
		title: 'Notifications',
		show: 'Voir',
		empty: 'Aucune notification',
		error: {
			product:
				'Une erreur est survenue lors de la %{method} du produit: %{name}',
			category:
				'Une erreur est survenue lors de la %{method} de la catégorie: %{name}',
			priceCategory:
				'Une erreur est survenue lors de la %{method} de la catégorie de prix: %{name}',
		},
		toast: {
			warning: 'Une situation mérite votre attention',
			error: 'Il y a eu des erreurs',
			forbidden: 'Accès refusé',
			success: 'Action effectuée avec succès',
			unauthorized:
				"Vous n'avez pas les droits suffisants pour effectuer cette action",
		},
		type: {
			WARNING: 'Attention',
			ERROR: 'Erreur',
			INFO: 'Info',
			SUCCESS: 'Succès',
		},
		no_detail: 'Pas de détail supplémentaire',
	},
	method: {
		PATCH: 'mise à jour',
		PUT: 'mise à jour',
		POST: 'création',
		DELETE: 'suppression',
	},
	no_access: "Vous n'avez pas accès à l'outil de gestion de la carte en ligne",
	no_access_reject:
		"Vous n'avez pas accès à l'outil de gestion de la carte en ligne, un patch va être prochainement déployé. Veuillez synchroniser vos iPads. Vous aurez de nouveau accès à cet outil après la prochaine clôture de service. ",
	no_access_explained:
		"Vous n'avez pas accès à l'outil de gestion de la carte en ligne. Vous avez surement déjà configuré votre Carte, pour plus de renseignement veuillez contacter le support.",
	no_access_tax_rate_empty:
		"Vous n'avez pas accès à l'outil de gestion de la carte en ligne. Veuillez contacter le support en indiquant le code d'erreur \"601\"",
	no_access_version:
		"Vous n'avez pas accès à l'outil de gestion de la carte en ligne. Veuillez mettre à jours tous vos appareils",
	no_access_need_activation:
		"Vous n'avez pas accès à l'outil de gestion de la carte en ligne. Veuillez activer votre application sur un iPad",
	no_access_in_synchro:
		'Une synchronisation est en cours sur la carte en ligne. Veuillez réessayer dans quelques instants',
	no_access_maintenance:
		'L’application est en maintenance... veuillez nous excuser pour la gêne occasionnée.',
	no_access_multi_window:
		'Une session a été ouverte depuis un autre navigateur,',
	no_access_restriction: "Vous n'avez pas access à cette section",
	no_access_multi_window_2:
		'Cliquez sur le bouton ci-dessous pour générer une nouvelle session.',
	no_access_multi_window_button: 'Activer ma session',
	multi_session_master_mono_use:
		"La session a été ouverte par l'établissement gérant. Pour accéder à votre carte veuillez le contacter.",
	wrong_url: 'Page non trouvée',
	browser_compatibility: {
		version_title: 'Navigateur obsolète',
		version_label:
			'Afin de vous offrir une experience optimale, veuillez passer sur la dernière version de Google Chrome ou Firefox',
		chrome: 'Google Chrome',
		firefox: 'Mozilla Firefox',
		screen_size_title: 'Votre écran est trop petit',
		screen_size_label:
			'Afin de vous offrir une experience optimale, veuillez passer sur un ordinateur avec un ecran plus grand.',
	},
	icon: {
		search: 'Chercher une icône',
	},
	title: {
		denomination: 'Dénomination',
		informations: 'Informations',
		price: 'Prix',
		supplements: 'Suppléments',
		exclusions: 'Exclusions',
		color: 'Couleur',
		icon: 'Icône',
		floors: 'Salles',
		service: 'Carte',
	},
	offline: 'Attention vous êtes hors ligne',
	tutorial: {
		interactTuto: 'Tutoriel intéractif',
		noDemo: 'Ne pas suivre la démo',
		yesDemo: 'Suivre la démo',
		nextStep: 'Etape suivante',
		leftDemo: 'Quitter la démo',
		back: 'Retour',
		initial_popup: {
			title: 'Vous souhaitez découvrir notre outil de carte web ?',
			text: `Vous ne savez pas par ou commencer ? vous pouvez lire l'aide écrite. Vous pourrez également y revenir plus tard via le bouton "Besoin d'aide ?".`,
			tutorial: 'Tutoriel',
			help: 'Aide',
			no_thank: 'Non merci',
		},
		topics: {
			endDemoTopics: 'Fin de la démo Rubriques',
			step1: {
				content:
					'Cette partie de l’interface vous permet de naviguer entre les différentes rubriques de création de votre carte.',
				title: 'Rubriques',
			},
			step2: {
				content:
					'La section Catégories vous permet de gérer les catégories dans lesquelles seront classés vos produits.',
				title: 'Catégories',
			},
			step3: {
				content: `Consultez la rubrique "Besoin d'aide" pour revoir le tutoriel intéractif ou lire l'aide écrite.`,
				title: "Besoin d'aide",
			},
		},
		category: {
			endDemoCategory: 'Fin de la démo Catégorie',
			step1: {
				content:
					"Cette rubrique permet de créer des catégories dans lesquelles vous pourrez regrouper vos produits afin d'organiser votre carte.",
				title: 'Catégories',
			},
			step2: {
				content: 'Spécifiez le nom de votre nouvelle catégorie',
				title: 'Définir un nom',
			},
			step3: {
				content:
					'Spécifiez la couleur de votre nouvelle catégorie, afin de créer un repère visuel',
				title: 'Définir une couleur',
			},
			step4: {
				content:
					"Spécifiez l'icône de votre nouvelle catégorie, afin de créer un repère visuel",
				title: 'Définir une icône',
			},
			step5: {
				content:
					'Spécifiez la ou les salles où votre catégorie ne sera pas disponible',
				title: 'Exclusion de salle(s)',
			},
			step6: {
				content: `Si ce n'est pas déjà fait, donnez un nom à votre catégorie en cliquant sur "Retour" puis cliquer sur "Enregistrer" afin de poursuivre le tutoriel.`,
				title: 'Enregistrer',
			},
			step7: {
				content:
					"Vous pouvez changer l'ordre de vos catégories grâce au glisser/déposer",
				title: "Modifier l'ordre",
			},
			step8: {
				content:
					"Vous pouvez éditer votre catégorie en cliquant dessus, et la supprimer en cliquant sur l'icône poubelle",
				title: 'Editer / Supprimer',
			},
		},
		product: {
			endDemoProduct: 'Fin du tutoriel Produits',
			step1: {
				content:
					"Cette rubrique permet de créer des produits de trois manières différentes : rapide, détaillée, ou à partir d'une carte existante",
				title: 'Produits',
			},
			step2: {
				content:
					"Cliquez sur le bouton + pour ajouter un produit de façon rapide, ou détaillée, ou copier un produit d'une carte existante",
				title: 'Ajouter un produit',
			},
			step3: {
				content: 'Cliquez sur ce bouton pour ajouter un produit rapidement',
				title: 'Ajout rapide',
			},
			step4: {
				content:
					'Une nouvelle ligne vide se crée, renseignez toutes les informations sur votre produit (nom, prix, catégorie, etc.) en sélectionnant directement une case. Veuillez commencer par compléter le champ "nom" afin d\'initialiser les autres cellules.',
				title: 'Ajout rapide',
			},
			step5: {
				content:
					"A droite de la ligne, le premier bouton permet d'enregistrer votre produit (la case 'nom' doit être remplie pour enregistrer un produit), le second permet la suppression de votre produit",
				title: 'Enregistrer / Supprimer',
			},
			step6: {
				content:
					'Un champ de recherche ainsi que des filtres peuvent être appliqués si vous souhaitez rechercher un ou plusieurs produits en particulier',
				title: 'Recherche / Filtres',
			},
			step7: {
				content:
					"Une fonction Annuler / Rétablir est disponible, en cas d'erreur de saisie",
				title: 'Annuler / Rétablir',
			},
			step8: {
				content:
					'Cliquez sur le bouton ⊕, pour ajouter un produit de façon détaillée',
				title: 'Ajouter un produit',
			},
			step9: {
				content: 'Cliquez sur ce bouton pour ajouter un produit détaillé',
				title: 'Ajout détaillé',
			},
			step10: {
				content: 'Spécifiez le nom de votre produit',
				title: 'Nom du produit',
			},
			step11: {
				content:
					'Spécifiez le nom court, le SKU et la description de votre produit',
				title: 'Informations supplémentaires (facultatif)',
			},
			step12: {
				content:
					'Les informations relatives au prix de votre produit (prix au kilo, prix en happy hour, etc...)',
				title: 'Prix',
			},
			step13: {
				content:
					'Les informations générales de votre produit (TVA, Type, Catégorie, etc.). TVA et Type sont obligatoires pour enregistrer votre produit',
				title: 'Informations générales',
			},
			step14: {
				content:
					'Spécifiez une option pour la cuisine, au préalable configurée dans la rubrique "Options cuisine"',
				title: 'Option cuisine',
			},
			step15: {
				content:
					'Spécifiez une pastille de couleur pour le différencier des autres produits ou le catégoriser',
				title: 'Définir une couleur',
			},
			step16: {
				content:
					'Spécifiez la ou les salles où votre produit ne sera pas disponible',
				title: 'Exclusion de salle(s)',
			},
			step17: {
				content:
					'Enregistrez votre produit. Vous devez configurer, au minimum, un nom, un prix, une TVA et un type afin de pouvoir sauvegarder votre produit',
				title: 'Enregistrer',
			},
			step18: {
				content:
					'Votre produit a bien été enregistré. Vous pouvez créer une nouvelle entrée de produit rapidement en effectuant la commande Shift + Entrer',
				title: 'Récapitulatif',
			},
			step19: {
				content:
					'Une pastille située en bas en droite de la cellule vous permet de dupliquer la valeur sur plusieurs éléments',
				title: "Duplication d'informations",
			},
			step20: {
				content:
					'Vous retrouvez toutes vos catégories de produit sur le panel de gauche, sélectionnez en une',
				title: 'Catégories de produit',
			},
			step21: {
				content:
					"Vous pouvez assigner un produit à une catégorie de produit directement depuis cette page, faites un glisser/déposer d'un produit ou d'un espace",
				title: 'Assigner un produit à une catégorie',
			},
		},
		productMenu: {
			endDemoProductMenu: 'Fin de la démo Menu',
			step1: {
				content:
					'Cette rubrique permet la gestion des menus (création, édition, suppression)',
				title: 'Menu',
			},
			step2: {
				content: 'Cliquez sur le bouton ⊕ pour créer votre menu',
				title: 'Création du menu',
			},
			step3: {
				content: "La création de menu s'effectue en 4 étapes",
				title: 'Menu par étapes',
			},
			step4: {
				content:
					'Spécifiez le nom de votre menu et renseignez, si besoin, les informations facultatives. Vous pouvez également rendre inactif votre menu.',
				title: 'Nom du menu',
			},
			step5: {
				content: 'Spécifiez la couleur de votre menu',
				title: 'Couleur du menu',
			},
			step6: {
				content: `Si ce n'est pas déjà fait, donnez un nom à votre menu en cliquant sur "Retour" puis cliquer sur "Suivant" afin de poursuivre le tutoriel.`,
				title: 'Fin de la première partie',
			},
			step7: {
				content:
					'Spécifiez la ou les salles où votre menu ne sera pas disponible',
				title: 'Exclusion de salle(s)',
			},
			step8: {
				content: 'Spécifiez le prix de votre menu',
				title: 'Prix du menu',
			},
			step9: {
				content: `Si ce n'est pas déjà fait, renseignez un prix en cliquant sur "Retour" puis cliquer sur "Suivant" afin de poursuivre le tutoriel.`,
				title: 'Fin de la deuxième partie',
			},
			step10: {
				content:
					'Cette partie vous permet de créer les niveaux de votre menu (défaut: Entrée / Plat). Vous pourrez définir les plats en fonction des différents niveaux de menu',
				title: 'Gestion des niveaux de menu',
			},
			step11: {
				content: 'Cliquez ici pour ajouter un niveau de menu (ex: Dessert)',
				title: 'Nouveau niveau',
			},
			step12: {
				content:
					'Un niveau de menu peut contenir un nom, une icône et quelques options',
				title: "Description d'un niveau de menu",
			},
			step13: {
				content: 'Spécifiez le nom de votre niveau de menu',
				title: 'Nom du niveau',
			},
			step14: {
				content: 'Spécifiez les options de votre niveau',
				title: 'Options',
			},
			step15: {
				content: 'Spécifiez une icône',
				title: 'Icône',
			},
			step16: {
				content:
					'Enregistrez votre niveau de menu afin de définir les différents plats qui le constitueront',
				title: 'Sauvegarder le niveau de menu',
			},
			step17: {
				content:
					'Spécifiez le ou les plat(s) que vous souhaitez dans votre niveau de menu',
				title: 'Définir les produits',
			},
			step18: {
				content:
					'Cliquez sur + Produit pour ajouter un produit dans le niveau de menu "Entrée"',
				title: 'Ajouter un produit',
			},
			step19: {
				content:
					'Le panel de gauche recense les catégories de plat que vous avez définies préalablement',
				title: 'Catégories de plat',
			},
			step20: {
				content:
					'Le panel de droite recense tous les produits de la catégorie sélectionnée. Pour ajouter un produit, cochez la case',
				title: 'Choix du produit',
			},
			step21: {
				content: 'Sauvegardez vos modifications',
				title: 'Sauvegarder',
			},
			step22: {
				content:
					"Récapitulatif de vos niveaux de menu et des produits qu'ils contiennent. Vous pouvez les réorganiser au sein d'un niveau ou les déplacer d'un niveau à l'autre grâce au glisser/déposer",
				title: 'Récapitulatif',
			},
			step23: {
				content:
					'En cliquant sur votre produit, vous pouvez le modifier rapidement. Définir une couleur, interdire une salle ou définir un prix en particulier',
				title: "Edition rapide d'un produit",
			},
			step24: {
				content:
					"Fin de la troisième étape, si vous avez terminé de compléter tous vos niveaux de menu, l'étape suivante est un récapitulatif de votre menu",
				title: 'Fin de la troisième étape',
			},
			step25: {
				content: 'Récapitulatif des différentes informations de votre menu',
				title: 'Récapitulatif de votre menu',
			},
			step26: {
				content: "Valider votre menu pour pouvoir l'utiliser",
				title: 'Validation',
			},
			step27: {
				content: 'Vous revenez sur la liste de vos menus existants.',
				title: 'Récapitulatif des menus',
			},
		},
		optionsKitchen: {
			endDemoOptionKitchen: 'Fin de la démo Options cuisine',
			step1: {
				content: `Cette rubrique permet de créer des options de cuisine regroupées par catégorie (ex : dans la catégorie d'option "Cuisson", vous pourrez proposer les options "Saignant", "A point", etc.)`,
				title: 'Options Cuisine',
			},
			step2: {
				content:
					"Cliquez ici pour ajouter une catégorie d'options cuisine et poursuivre le tutoriel",
				title: 'Ajouter une catégorie',
			},
			step3: {
				content:
					"Définissez les caractéristiques de votre catégorie d'option cuisine",
				title: 'Description',
			},
			step4: {
				content: 'Spécifiez le titre de votre catégorie (Ex: Cuisson)',
				title: 'Nom de la catégorie',
			},
			step5: {
				content:
					"Définissez si la catégorie d'options sera systématiquement obligatoire pour chaque produit qui y sera associé et le type de choix possibles.",
				title: 'Informations de la catégorie',
			},
			step6: {
				content: "Spécifiez l'icône de votre catégorie",
				title: 'Icône',
			},
			step7: {
				content: 'Spécifiez la couleur de votre catégorie',
				title: 'Couleur',
			},
			step8: {
				content:
					'Spécifiez la ou les salles où votre catégorie ne sera pas disponible',
				title: 'Exclusion de salle(s)',
			},
			step9: {
				content: `Si ce n'est pas déjà fait, donnez un nom à votre option cuisine en cliquant sur "Retour" puis cliquer sur "Enregistrer" afin de poursuivre le tutoriel.`,
				title: 'Enregistrer',
			},
			step10: {
				content:
					"Vous pouvez réorganiser vos catégories d'options cuisine grâce au glisser/déposer, supprimer une catégorie en cliquant sur l'icône poubelle, éditer une catégorie d'option en cliquant sur le crayon. Cliquez sur la ligne d'une catégorie pour ajouter les options qui lui seront associées.",
				title: 'Récapitulatif',
			},
			step11: {
				content:
					"Ajoutez une option ou un espace (pour différencier les différentes options) à votre catégorie d'options cuisine",
				title: 'Ajouter une option',
			},
			step12: {
				content: 'Spécifiez le nom de votre option (ex: Saignant)',
				title: "Nom de l'option",
			},
			step13: {
				content:
					'Spécifiez, si besoin, le prix de votre option (Ex: Saignant +2.00€)',
				title: 'Prix',
			},
			step14: {
				content: 'Spécifiez la couleur pour votre option',
				title: 'Couleur',
			},
			step15: {
				content:
					'Spécifiez la ou les salles où votre option ne sera pas disponible',
				title: 'Exclusion de salle(s)',
			},
			step16: {
				content: 'Enregistrez votre option',
				title: 'Enregistrer',
			},
			step17: {
				content:
					"Spécifiez les produits auxquels vous souhaitez associer votre catégorie d'options, en cliquant sur cette icône",
				title: 'Assignation de produit',
			},
			step18: {
				content:
					'Sélectionnez les produits qui seront impactés par votre option de cuisine en cliquant sur le produit ou la checkbox',
				title: 'Assignation de produit',
			},
			step19: {
				content: 'Enregistrez vos produits impactés par cette option',
				title: 'Enregistrer',
			},
			step20: {
				content:
					"Vous revenez sur la liste de vos catégories d'options cuisine existantes.",
				title: 'Récapitulatif',
			},
		},
		tax: {
			endDemoTax: 'Fin de la démo Taxes',
			step1: {
				content:
					'Cette rubrique permet de créer des TVA supplémentaires. Par défaut, 4 TVA sont prédéfinies et sont de rigueur en France. Vous pouvez en ajouter ou modifier celles existantes',
				title: 'T.V.A',
			},
			step2: {
				content:
					"La partie de gauche récapitule l'ensemble des TVA existantes (prédéfinies + créées)",
				title: 'Récapitulatif',
			},
			step3: {
				content: 'Spécifiez le nom de la taxe',
				title: 'Nom',
			},
			step4: {
				content:
					'Vous pouvez spécifier un taux différent si le produit est consommé sur place ou à emporter',
				title: 'Taux différenciel',
			},
			step5: {
				content:
					"En spécifiant une taxe par défaut, celle-ci s'appliquera automatiquement à chaque nouveau produit",
				title: 'Taux par défaut',
			},
			step6: {
				content: 'Enregistrez votre taxe',
				title: 'Enregistrer',
			},
			step7: {
				content: 'Vous pouvez ajouter une nouvelle taxe en cliquant ici',
				title: 'Nouvelle taxe',
			},
		},
		priceCategory: {
			endDemoPriceCategory: 'Fin de la démo catégorie de prix',
			step1: {
				content:
					'Cette rubrique permet de créer des catégories de prix (Ex: prix Happy Hour, à emporter, en terrasse...)',
				title: 'Catégorie de Prix',
			},
			step2: {
				content:
					'Cliquez ici pour créer une nouvelle catégorie et poursuivre le tutoriel',
				title: 'Nouvelle catégorie',
			},
			step3: {
				content:
					'Ce formulaire permet de paramétrer les caractéristiques de la catégorie de prix',
				title: 'Catégorie de Prix',
			},
			step4: {
				content: 'Spécifiez le nom de votre nouvelle catégorie',
				title: 'Nom',
			},
			step5: {
				content:
					"Spécifiez un nom court (facultatif) et choisissez d'activer ou désactiver la catégorie de prix",
				title: 'Nom court',
			},
			step6: {
				content:
					"Spécifiez le ou les moment(s) où le nom court de votre catégorie s'affichera (si vous avez renseigné un nom court)",
				title: 'Utilisation du nom court',
			},
			step7: {
				content: `Par défaut, votre catégorie est disponible toute la journée. Vous pouvez décocher "Toute la journée" et définir un créneau horaire pendant lequel votre catégorie de prix sera active (Ex: Happy Hour de 17h à 19h)`,
				title: 'Disponibilité heure',
			},
			step8: {
				content: `Par défaut, votre catégorie est disponible toute la semaine. Vous pouvez décocher "Tous les jours" et définir les jours de disponibilité de votre catégorie.`,
				title: 'Disponibilité jour',
			},
			step9: {
				content: `Spécifiez la ou les salles où votre catégorie de prix sera active`,
				title: 'Salle(s) concernée(s)',
			},
			step10: {
				content: `Si ce n'est pas déjà fait, donnez un nom à votre catégorie de prix en cliquant sur "Retour" puis cliquer sur "Enregistrer" afin de poursuivre le tutoriel.`,
				title: 'Enregistrer',
			},
			step11: {
				content: `Votre catégorie de prix a bien été enregistrée. Editez une catégorie en cliquant dessus, ou modifier leur ordre grâce au glisser-déposer`,
				title: 'Récapitulatif des catégories de prix',
			},
			step12: {
				content: `Les associations permettent de voir quel produit / menu / option cuisine est associé à cette catégorie de prix`,
				title: 'Associations',
			},
			step13: {
				content: `En cliquant sur une catégorie de prix, vous pourrez éditer les informations et l'associer à une catégorie de produit`,
				title: 'Association avec une catégorie de produit',
			},
			step14: {
				content: `La configuration rapide vous permet de spécifier la ou les catégories de produits qui seront automatiquement impactées et la façon dont elles seront impactées. Vous pouvez également associer la catégorie de prix à des produits au cas par cas, dans les fiches produit`,
				title: 'Configurer les catégories de produits associées',
			},
		},
	},
	dateZonePicker: {
		title_master: "Gérer la date et le mode d'édition",
		title_mono: "Gérer la date d'édition",
		activated: 'Activé',
		select: 'Sélectionner',
		date: {
			title: 'Calendrier',
			description: 'Appliquer les modifications sur la carte du',
		},
		nbCompanies: '%{nb} établissement(s)',
		management: {
			title: 'Visualisation de la carte',
			master: 'Siège',
			master_description: 'Modifications centralisées',
			zone: 'Zones',
			zone_description: 'Modifications par zone',
			company: 'Sites',
			company_description: 'Modifications par site',
		},
		prodiverChanges: {
			title: 'Changements exterieurs',
			text: 'Il y a %{n} patchs effectués depuis une application tierce.',
			button: 'Appliquer les patchs',
		},
		mode: {
			master: 'SIEGE',
			zone: 'ZONE',
			company: 'SITE',
		},
	},
	productStock: {
		currentStock: 'QTE act.',
		endOfServiceStock: 'QTE fin',
		entry: 'Entrée',
		exit: 'Sortie',
		quantity: 'Quantité',
		unitPrice: "Prix d'achat HT",
		comment: 'Commentaire',
		stockAfterMovement: 'Stock après mouvement',
		effectiveDate: "Date d'effet",
		effectiveOn: 'Effet le %{date}',
		choiceTracking: 'Activer le suivi en quantité',
		choicePriceOnly: "Ajouter seulement un prix d'achat HT",
		filterManaged: 'Suivi en quantité',
		filterInStock: 'Stock disponible',
		filterNoStock: 'Stock indisponible',
		filterUnmanaged: 'Aucun suivi',
		colPrice: 'Prix TTC',
		colPurchasePrice: "Prix d'achat\nHT",
		colTax: 'TVA',
		colType: 'Type',
		colCategories: 'Catégorie(s)',
		colPlace: 'Lieu de fabr.',
		colFollowType: 'Suivi',
		serviceMovementBlocked: 'Mouvements manuels non autorisés (suivi par service)',

		unmanagedLabel: 'Produit sans gestion de stock',
		noMovementPending: 'Aucun mouvement en attente',
		addMovement: 'Ajouter un mouvement',
		followTypeLabel: 'Type de suivi',
		followTypeGlobal: 'Global (stock permanent)',
		alertValueLabel: "Valeur d'alerte",
		alertValueHint: 'La couleur du badge de quantité change à partir de cette valeur',
		printReportLabel: 'Imprimer sur le rapport des quantités',
		next: 'Suivant',
		insufficientStock: 'stock insuffisant',
		disclaimer: "La synchronisation des stocks s'effectue lors de la clôture avec le dernier service enregistré sur le système de caisse. Pour en savoir plus, cliquez sur Besoin d'aide ? et accédez à la section Gestion des stocks.",
		footnote: "(* peut varier selon les ventes et mouvements effectués depuis le système de caisse en cours de service)",
		confirmRemoveTitle: 'Retirer de la gestion des quantités',
		confirmRemoveText: 'Voulez-vous vraiment retirer %{name} de la gestion des quantités ?',
		confirmRemoveSub: 'Les mouvements en attente seront également supprimés.',
		confirmRemoveBtn: 'Retirer',
		selectAllVisible: 'Tout sélectionner',
		deselectAll: 'Tout désélectionner',
		selectedCount: '%{n} produit(s) sélectionné(s)',
		bulkEditButton: "Modifier le prix d'achat HT",
		bulkDeleteButton: "Effacer le prix d'achat HT",
		bulkPurchasePrice: {
			title: "Modifier le prix d'achat HT — %{n} produit(s)",
			confirmation:
				"Vous allez modifier le prix d'achat HT de %{n} produit(s). Continuer ?",
			deleteConfirmation:
				"Vous allez effacer le prix d'achat HT de %{n} produit(s). Continuer ?",
			modeFixed: 'Renseigner une valeur fixe',
			modeDiscount: 'Appliquer une réduction sur le prix de vente HT',
			discountCoefficient: 'Coefficient',
			discountAmount: 'Montant (€)',
			discountPercent: 'Pourcentage (%)',
			example:
				"Exemple : pour un produit vendu 12,00 € TTC (TVA 10 %), le prix de vente HT est de 10,91 €. Un coefficient de 3 donnera un prix d'achat HT de 3,64 €. Une réduction de 20 % donnera 8,73 €, une réduction de 2,00 € donnera 8,91 €.",
		},
	},
	common: {
		cancel: 'Annuler',
		save: 'Enregistrer',
	},
};
